"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8382],{

/***/ 75217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51252);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56941);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91121);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49635);
/* harmony import */ var _elements_utils_priceTag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97037);






var config = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])().publicRuntimeConfig;
var fullySupportedBoxStyle = {
    margin: 0,
    padding: '5px',
    display: 'inline-block',
    border: '1px solid #ff5050',
    borderRadius: '5px'
};
var BeneficiaryProgramCard = function(props) {
    var _program = props.program, title = _program.title, ngo = _program.ngo, price = _program.price, image = _program.image, alt = _program.alt, programLink = _program.programLink, headline = _program.headline, displayName = _program.displayName, isInventoryAvailable = _program.isInventoryAvailable, type = _program.type;
    var lazyLoadImage = props.lazyLoadImage, newTab = props.newTab, position = props.position, theme = props.theme;
    var imageType = props.imageType || 'thumbnail';
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                rel: "noopener noreferrer",
                className: "no-hover-a",
                style: {
                    cursor: 'pointer'
                },
                href: "/beneficiary/".concat(programLink),
                target: newTab ? '_blank' : '_self',
                onClick: function() {
                    var eventInfo = {
                        position: position + 1,
                        productName: title,
                        productId: null,
                        ngo: ngo,
                        url: window.location.toString()
                    };
                    if (window.eventDispatcher) {
                        window.eventDispatcher.dispatchEventSync('beneficiaryProgramClick', eventInfo, {
                            amplitude: true
                        });
                    }
                    return true;
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        width: "100%",
                        style: {
                            opacity: 1
                        },
                        src: image,
                        alt: alt,
                        type: imageType,
                        lazyLoad: lazyLoadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                className: "card-title text-clamp-3",
                                style: {
                                    lineHeight: '1.375rem'
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "darker-grey",
                                    children: displayName || headline || title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-inline-flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "beneficiary-panel-icon",
                                        style: {
                                            width: '20px',
                                            height: '20px'
                                        },
                                        src: "".concat(config.cdnUrl, "/static/icons/support-beneficiary-icon.png"),
                                        alt: "support beneficiary icon"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-muted ml-1",
                                        children: ngo
                                    })
                                ]
                            }),
                            !isInventoryAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    position: 'relative'
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "card-price",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        className: "price",
                                        style: fullySupportedBoxStyle,
                                        children: " Fully Supported "
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                    className: "price",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_utils_priceTag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            price: price,
                                            session: props.session,
                                            theme: theme
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "sh",
                                            children: " per month "
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
BeneficiaryProgramCard.defaultProps = {
    size: {
        lg: '4',
        sm: '12',
        xs: '12'
    },
    className: 'd-flex program-card-11 stack-3'
};
/* harmony default export */ __webpack_exports__["Z"] = (BeneficiaryProgramCard);


/***/ }),

/***/ 2386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 18 18",
        role: "presentation",
        "aria-hidden": "true",
        focusable: "false",
        style: {
            height: '10px',
            width: '10px',
            fill: 'currentcolor'
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: props.color,
            style: {
                background: '#FFF'
            },
            d: "m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z",
            fillRule: "evenodd"
        })
    }));
};


/***/ }),

/***/ 71629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fundraisersPanel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/esm/index.js + 9 modules
var esm = __webpack_require__(82515);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./lib/useGetCampaignsData.js



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useGetCampaignsData_config = (0,config["default"])().publicRuntimeConfig;
var useGetCampaignsData = function(campaignIds) {
    var apiUrl = "search?fq=type:campaign&fq=id:(".concat(encodeURIComponent(campaignIds.join(' ')), ")&rows=").concat(campaignIds.length);
    var ref = (0,esm/* default */.ZP)(apiUrl, function(url) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        url = 'https://fundraisers.giveindia.org/' + url;
        //config.fundraisersPlatformUrl + url;
        return fetch_default().apply(void 0, [
            url
        ].concat(_toConsumableArray(args))).then(function(res) {
            return res.json();
        }).then(function(res) {
            return res.response.docs;
        });
    }, {
        refreshInterval: 60000
    }), campaigns = ref.data, error = ref.error;
    return {
        campaigns: campaigns,
        error: error
    };
};
/* harmony default export */ var lib_useGetCampaignsData = (useGetCampaignsData);

// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(51252);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Card.js
var Card = __webpack_require__(56941);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardText.js
var CardText = __webpack_require__(26094);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Progress.js
var Progress = __webpack_require__(90436);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(97975);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Container.js
var Container = __webpack_require__(98595);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(10267);
// EXTERNAL MODULE: ./components/chrome/elements/utils/index.js + 6 modules
var utils = __webpack_require__(78659);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/fundraisersPanel/index.js




// import './fundraisersPanel.scss';


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FundraisersPanel = function(param) {
    var featuredFundraisers = param.featuredFundraisers, tenantConfig = param.tenantConfig, session = param.session, activeTab = param.activeTab;
    var numberOfTilesToShow = 3;
    var ref4 = (0,react.useState)(numberOfTilesToShow), limit = ref4[0], setLimit = ref4[1];
    var ref1 = (0,react.useState)(), featuredFundraisersData = ref1[0], setFeaturedFundraisersData = ref1[1];
    var ref2 = (0,react.useState)(false), hasFundraisersWithData = ref2[0], setHasFundraisersWithData = ref2[1];
    // Fetch other fields (raised_amount_in_inr, creator_name, permalink, image) of featuredFundraisers
    var campaignsData = '';
    if (featuredFundraisers) {
        var ref3 = lib_useGetCampaignsData(featuredFundraisers.map(function(campaign) {
            return campaign.id;
        })), campaigns = ref3.campaigns, error = ref3.error;
        campaignsData = campaigns;
    }
    (0,react.useEffect)(function() {
        // Merge other details to featuredFundraisers
        if (campaignsData) {
            var _loop = function(i) {
                mergedData.push(_objectSpread({}, featuredFundraisers[i], campaignsData.find(function(campaigns) {
                    return campaigns.id === featuredFundraisers[i].id;
                })));
            };
            var mergedData = [];
            for(var i = 0; i < featuredFundraisers.length; i++)_loop(i);
            setFeaturedFundraisersData(mergedData);
        }
    }, [
        campaignsData
    ]);
    (0,react.useEffect)(function() {
        if (featuredFundraisersData === null || featuredFundraisersData === void 0 ? void 0 : featuredFundraisersData.length) {
            var hasFundraisers = featuredFundraisersData.filter(function(item) {
                return item === null || item === void 0 ? void 0 : item.slug;
            });
            hasFundraisers.length && setHasFundraisersWithData(true);
        }
    }, [
        featuredFundraisersData
    ]);
    var featuredFundraisersCard = function(campaigns) {
        return campaigns === null || campaigns === void 0 ? void 0 : campaigns.map(function(campaign, idx) {
            var ref;
            return (campaign === null || campaign === void 0 ? void 0 : campaign.slug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "fundrasier-card-homepage",
                lg: "4",
                md: "6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: campaign.permalink,
                    onClick: function() {
                        var eventInfo = {
                            panelName: campaign.title
                        };
                        if (window.eventDispatcher) {
                            window.eventDispatcher.dispatchEventSync('fundraiser-card', eventInfo, {
                                amplitude: true
                            });
                        }
                    },
                    style: {
                        textDecoration: 'none'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        className: "missions-card fcm-tile",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "missions-card-img-wrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: '100%'
                                    },
                                    src: campaign.image,
                                    alt: campaign.title,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardText/* default */.Z, {
                                className: "missions-card-text-box ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            paddingBottom: '10px'
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mission-card-title",
                                            style: {
                                                color: '#444'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "darker-grey",
                                                    children: campaign.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "sh w-100",
                                                    children: [
                                                        "\xa0by\xa0",
                                                        campaign.creator_name
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            color: '#444444',
                                            paddingBottom: '5px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(utils.PriceTag, {
                                                price: campaign.raised_amount_in_inr,
                                                theme: tenantConfig.theme,
                                                session: session
                                            }),
                                            ' ',
                                            "\xa0Raised"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "progress-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                                className: "supporter-process-bar",
                                                value: Math.round(campaign.raised_amount_in_inr / campaign.target_amount_in_inr * 100)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: '#444444',
                                                    paddingTop: '7px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: " monthly-count-supporters",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils.PriceTag, {
                                                                price: campaign.target_amount_in_inr,
                                                                style: {
                                                                    color: '#444444'
                                                                },
                                                                theme: tenantConfig.theme,
                                                                session: session
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: " completed-supporters-homepage",
                                                        children: campaign === null || campaign === void 0 ? void 0 : (ref = campaign.supporter_count) === null || ref === void 0 ? void 0 : ref.toLocaleString('en-in')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: '#444444',
                                                    paddingBottom: '5px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: " monthly-count-supporters",
                                                            children: "Goal"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: " completed-supporters-homepage",
                                                        children: "Supporters"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: campaign.permalink,
                                        onClick: function() {
                                            var eventInfo = {
                                                panelName: campaign.title
                                            };
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('fundraiser-card-btn', eventInfo, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            color: "primary",
                                            className: "btn-full-width btn btn-primary",
                                            children: campaign.cta
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, idx) : null;
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasFundraisersWithData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "panel-padding",
                style: {
                    marginTop: '40px',
                    marginBottom: '40px'
                },
                children: [
                    activeTab === 'fundraiser' ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "feature-fundraisers-heading",
                                children: "Featured Fundraisers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fundraiser-divider-heading"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "fp-cards-container",
                        children: featuredFundraisersCard(featuredFundraisersData === null || featuredFundraisersData === void 0 ? void 0 : featuredFundraisersData.slice(0, limit))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n\t\t\t\t\t.completed-supporters-homepage{\n\t\t\t\t\t\tfloat: right;\n\t\t\t\t\t\tcolor: #444444 !important;\n\t\t\t\t\t}\n\t\t\t\t"
            })
        ]
    }));
};
/* harmony default export */ var fundraisersPanel = (FundraisersPanel);


/***/ }),

/***/ 48382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "al": function() { return /* reexport */ BeneficiaryPanel; },
  "Pd": function() { return /* reexport */ campaignPanel; },
  "OO": function() { return /* reexport */ panels_CampaignPanelNew; },
  "JL": function() { return /* reexport */ carouselPanel; },
  "vp": function() { return /* reexport */ causePanel; },
  "c0": function() { return /* reexport */ CorporatePartners; },
  "ac": function() { return /* reexport */ ctaPanel/* default */.Z; },
  "CF": function() { return /* reexport */ donorBenfits; },
  "ME": function() { return /* reexport */ index1; },
  "XL": function() { return /* reexport */ fundraisersPanel/* default */.Z; },
  "Tc": function() { return /* reexport */ giveAssuredPanelNew; },
  "IF": function() { return /* reexport */ imagePanel; },
  "JY": function() { return /* reexport */ ImpactCard; },
  "cx": function() { return /* reexport */ indiaCovidResponse_index; },
  "M4": function() { return /* reexport */ joinMissionPanel; },
  "zb": function() { return /* reexport */ locationPanel; },
  "kA": function() { return /* reexport */ index; },
  "UA": function() { return /* reexport */ missionPanelNew; },
  "zQ": function() { return /* reexport */ missionsCard/* default */.Z; },
  "PN": function() { return /* reexport */ missionsPanel; },
  "SE": function() { return /* reexport */ newsletterPanel/* default */.Z; },
  "W2": function() { return /* reexport */ PatnersHomepage; },
  "$o": function() { return /* reexport */ programHighlightPanel; },
  "oB": function() { return /* reexport */ programPanel/* default */.Z; },
  "un": function() { return /* reexport */ StartFundraisersPanel; },
  "ts": function() { return /* reexport */ tagsPanel; },
  "Ku": function() { return /* reexport */ testimonialPanel; },
  "j7": function() { return /* reexport */ TestimonialPanelNew; },
  "Tf": function() { return /* reexport */ VideoPanel; },
  "O8": function() { return /* reexport */ whyGiveIndiaPanel_index; }
});

// UNUSED EXPORTS: DonateWithTrust, GiveAssuredPanel, GiveFeatures, Icrf, NewsletterPanelNew, SupportingFoundations

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react-contextual/dist/react-contextual.es.js
var react_contextual_es = __webpack_require__(80224);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Container.js
var es_Container = __webpack_require__(98595);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var es_Row = __webpack_require__(10267);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var es_Col = __webpack_require__(51252);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Progress.js
var Progress = __webpack_require__(90436);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(97975);
// EXTERNAL MODULE: ./components/chrome/elements/tag/index.js
var elements_tag = __webpack_require__(79310);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/onClickHandle.js
var onClickHandle = function(e, eventName, eventInfo, link) {
    e.preventDefault();
    if (window.eventDispatcher) {
        window.eventDispatcher.dispatchEventSync(eventName, eventInfo, {
            amplitude: true
        });
    }
    if (link) {
        window.location.href = link;
    }
};
/* harmony default export */ var panels_onClickHandle = (onClickHandle);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/campaignPanel/index.js









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var campaignPanel_config = (0,config["default"])().publicRuntimeConfig;
var CampaignPanel = function(param) {
    var className = param.className, title = param.title, description = param.description, needed = param.needed, completed = param.completed, size = param.size, image1 = param.image1, tags = param.tags, partnerImage = param.partnerImage, link = param.link, tenantConfig = param.tenantConfig;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, _objectSpread({}, size.left, {
                        className: "gi-campaign-image d-flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(campaignPanel_config.cdnUrl).concat(image1),
                                alt: title,
                                className: style_default().dynamic([
                                    [
                                        "fd1fa1fc8fb60fcc",
                                        [
                                            tenantConfig.theme.primaryCTA.textColor,
                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                            tenantConfig.theme.secondaryColor
                                        ]
                                    ]
                                ]) + " " + "gi-background-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(campaignPanel_config.cdnUrl).concat(partnerImage),
                                alt: title,
                                className: style_default().dynamic([
                                    [
                                        "fd1fa1fc8fb60fcc",
                                        [
                                            tenantConfig.theme.primaryCTA.textColor,
                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                            tenantConfig.theme.secondaryColor
                                        ]
                                    ]
                                ]) + " " + "partner-ngo-image"
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, _objectSpread({}, size.right, {
                        className: "gi-campaign-textbox d-flex justify-content-between f-d-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: style_default().dynamic([
                                    [
                                        "fd1fa1fc8fb60fcc",
                                        [
                                            tenantConfig.theme.primaryCTA.textColor,
                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                            tenantConfig.theme.secondaryColor
                                        ]
                                    ]
                                ]) + " " + "campaign-panel-top",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "fd1fa1fc8fb60fcc",
                                                [
                                                    tenantConfig.theme.primaryCTA.textColor,
                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                    tenantConfig.theme.secondaryColor
                                                ]
                                            ]
                                        ]) + " " + "tag-row",
                                        /*#__PURE__*/ children: typeof tags !== 'undefined' ? tags.map(function(tag, index) {
                                            /*#__PURE__*/ return (0,react.createElement)(elements_tag/* default */.Z, _objectSpread({}, tag, {
                                                key: index
                                            }));
                                        }) : []
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: style_default().dynamic([
                                            [
                                                "fd1fa1fc8fb60fcc",
                                                [
                                                    tenantConfig.theme.primaryCTA.textColor,
                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                    tenantConfig.theme.secondaryColor
                                                ]
                                            ]
                                        ]),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: style_default().dynamic([
                                            [
                                                "fd1fa1fc8fb60fcc",
                                                [
                                                    tenantConfig.theme.primaryCTA.textColor,
                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                    tenantConfig.theme.secondaryColor
                                                ]
                                            ]
                                        ]),
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: style_default().dynamic([
                                    [
                                        "fd1fa1fc8fb60fcc",
                                        [
                                            tenantConfig.theme.primaryCTA.textColor,
                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                            tenantConfig.theme.secondaryColor
                                        ]
                                    ]
                                ]) + " " + "progress-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "fd1fa1fc8fb60fcc",
                                                [
                                                    tenantConfig.theme.primaryCTA.textColor,
                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                    tenantConfig.theme.secondaryColor
                                                ]
                                            ]
                                        ]) + " " + "progress-text",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: style_default().dynamic([
                                                    [
                                                        "fd1fa1fc8fb60fcc",
                                                        [
                                                            tenantConfig.theme.primaryCTA.textColor,
                                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                                            tenantConfig.theme.secondaryColor
                                                        ]
                                                    ]
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "fd1fa1fc8fb60fcc",
                                                                [
                                                                    tenantConfig.theme.primaryCTA.textColor,
                                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                                    tenantConfig.theme.secondaryColor
                                                                ]
                                                            ]
                                                        ]) + " " + "bold-text",
                                                        children: needed
                                                    }),
                                                    " supporters needed"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: style_default().dynamic([
                                                    [
                                                        "fd1fa1fc8fb60fcc",
                                                        [
                                                            tenantConfig.theme.primaryCTA.textColor,
                                                            tenantConfig.theme.primaryCTA.backgroundColor,
                                                            tenantConfig.theme.secondaryColor
                                                        ]
                                                    ]
                                                ]) + " " + "completed bold-text",
                                                children: [
                                                    completed,
                                                    "% "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                        value: completed
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: link,
                                        onClick: function(e) {
                                            return panels_onClickHandle(e, 'campaign-givenow-click', {
                                                title: title,
                                                link: link
                                            }, link);
                                        },
                                        className: style_default().dynamic([
                                            [
                                                "fd1fa1fc8fb60fcc",
                                                [
                                                    tenantConfig.theme.primaryCTA.textColor,
                                                    tenantConfig.theme.primaryCTA.backgroundColor,
                                                    tenantConfig.theme.secondaryColor
                                                ]
                                            ]
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            color: tenantConfig.theme.primaryCTA.backgroundColor,
                                            className: "btn-full-width campaign-panel-givenow",
                                            children: "Feed a hungry child"
                                        })
                                    })
                                ]
                            })
                        ]
                    }))
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "fd1fa1fc8fb60fcc",
                dynamic: [
                    tenantConfig.theme.primaryCTA.textColor,
                    tenantConfig.theme.primaryCTA.backgroundColor,
                    tenantConfig.theme.secondaryColor
                ],
                children: ".campaign-panel-givenow{color:".concat(tenantConfig.theme.primaryCTA.textColor, ";\nbackground:").concat(tenantConfig.theme.primaryCTA.backgroundColor, "}\n.progress-bar{background:").concat(tenantConfig.theme.secondaryColor, "!important}")
            })
        ]
    }));
};
CampaignPanel.defaultProps = {
    className: 'gi-campaign-panel d-flex',
    title: 'mission 10 million meals',
    description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
    needed: 1270,
    completed: 80,
    size: {
        left: {
            xs: 12,
            sm: 12,
            md: '7',
            lg: '7',
            xl: '7'
        },
        right: {
            xs: 12,
            sm: 12,
            md: '5',
            lg: '5',
            xl: '5'
        }
    },
    tags: [
        {
            type: 'extremeneed',
            design: 'capsule'
        }, 
    ],
    image: '/static/images/campaign/target-image1.jpg',
    partnerImage: '/static/images/campaign/mission-partner-ngo.png',
    link: '#'
};
/* harmony default export */ var campaignPanel = ((0,react_contextual_es/* subscribe */.Ld)()(CampaignPanel));

// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
var react_responsive_default = /*#__PURE__*/__webpack_require__.n(react_responsive);
// EXTERNAL MODULE: ./components/chrome/elements/cards/squareCard/index.js + 1 modules
var squareCard = __webpack_require__(79632);
// EXTERNAL MODULE: ./components/chrome/elements/icons/rightArrowSmall.js
var rightArrowSmall = __webpack_require__(2386);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/causePanel/index.js










function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function causePanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function causePanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            causePanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var CausePanel = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CausePanel, _Component);
    var _super = _createSuper(CausePanel);
    function CausePanel(props) {
        _classCallCheck(this, CausePanel);
        var _this;
        _this = _super.call(this, props);
        causePanel_defineProperty(_assertThisInitialized(_this), "showAll", function() {
            _this.setState({
                showAll: true
            });
        });
        _this.state = {
            showAll: false
        };
        return _this;
    }
    _createClass(CausePanel, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                var _props = this.props, heading = _props.heading, data = _props.data;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    className: "panel-padding",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "jsx-cea1bd20fc7b8867",
                                children: heading
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_responsive_default()), {
                            minWidth: 768,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                className: "cause-panel-remove-margins",
                                children: data.map(function(item, index) {
                                    /*#__PURE__*/ return (0,react.createElement)(squareCard/* default */.Z, causePanel_objectSpread({}, item, {
                                        position: index,
                                        key: index,
                                        clickHandler: function(e) {
                                            return panels_onClickHandle(e, 'cause-panel-click', {
                                                index: index,
                                                cause: item.heading
                                            }, item.link);
                                        },
                                        show: true
                                    }));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((react_responsive_default()), {
                            maxWidth: 768,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                    className: "cause-panel-remove-margins",
                                    children: data.map(function(item, index) {
                                        /*#__PURE__*/ return (0,react.createElement)(squareCard/* default */.Z, causePanel_objectSpread({}, item, {
                                            position: index,
                                            key: index,
                                            clickHandler: function(e) {
                                                return panels_onClickHandle(e, 'cause-panel-click', {
                                                    index: index,
                                                    cause: item.heading
                                                }, item.link);
                                            },
                                            show: _this.state.showAll
                                        }));
                                    })
                                }),
                                !this.state.showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-cea1bd20fc7b8867" + " " + "text-right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        onClick: this.showAll,
                                        style: {
                                            color: '#444444',
                                            textDecoration: 'none',
                                            fontSize: '0.875rem',
                                            cursor: 'pointer'
                                        },
                                        className: "jsx-cea1bd20fc7b8867",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    paddingRight: '6px'
                                                },
                                                className: "jsx-cea1bd20fc7b8867",
                                                children: "View All"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrowSmall/* default */.Z, {})
                                        ]
                                    })
                                }) : null
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "cea1bd20fc7b8867",
                            children: ".cause-panel-remove-margins{margin-left:-10px!important;\nmargin-right:-10px!important}"
                        })
                    ]
                }));
            }
        }
    ]);
    return CausePanel;
}(react.Component);
CausePanel.defaultProps = {
    heading: 'Causes We Support',
    data: [
        {
            heading: 'health',
            initialText: '50 programs',
            hoverText: '1230 supporters',
            image: '/static/images/home/causes-health.jpg',
            link: '#'
        },
        {
            heading: 'women',
            initialText: '20 programs',
            hoverText: '1230 supporters',
            image: '/static/images/home/causes-women.jpg',
            link: '#'
        },
        {
            heading: 'education',
            initialText: '10 programs',
            hoverText: '1230 supporters',
            image: '/static/images/home/causes-education.jpg',
            link: '#'
        },
        {
            heading: 'differently abled',
            initialText: '7 programs',
            hoverText: '1230 supporters',
            image: '/static/images/home/causes-differentlyabled.jpg',
            link: '#'
        },
        {
            heading: 'elderly',
            initialText: '30 programs',
            hoverText: '1230 supporters',
            image: '/static/images/home/causes-elderly.jpg',
            link: '#'
        }, 
    ]
};
/* harmony default export */ var causePanel = ((0,react_contextual_es/* subscribe */.Ld)()(CausePanel));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/giveAssuredPanel/index.js






var giveAssuredPanel_config = (0,config["default"])().publicRuntimeConfig;
var GiveAssuredPanel = function(param) {
    var title = param.title, imageUrl = param.imageUrl, description = param.description, width = param.width;
    /*#__PURE__*/ return(_jsxs(Container, {
        className: "panel-padding",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                className: "gi-giveassured-panel",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: "12",
                        sm: "12",
                        md: "6",
                        lg: "8",
                        className: "giveassured-text-part",
                        /*#__PURE__*/ children: /*#__PURE__*/ _jsxs("div", {
                            className: "jsx-3193e754814490ee" + " " + "giveassured-text-panel",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: "".concat(giveAssuredPanel_config.cdnUrl, "/static/images/home/give-assured-badge20.png"),
                                    alt: "give assured badge",
                                    style: {
                                        height: '24pt'
                                    },
                                    className: "jsx-3193e754814490ee"
                                }),
                                /*#__PURE__*/ _jsx("h4", {
                                    style: {
                                        paddingTop: '1rem'
                                    },
                                    className: "jsx-3193e754814490ee",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "jsx-3193e754814490ee",
                                    children: description
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "jsx-3193e754814490ee" + " " + "read-more d-flex",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/giveassured",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('read-more-giveassured', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        className: "jsx-3193e754814490ee",
                                        children: "Read more"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(MediaQuery, {
                        minWidth: 768,
                        device: {
                            width: width
                        },
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: "12",
                            sm: "12",
                            md: "6",
                            lg: "4",
                            className: "giveassured-image-part",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "jsx-3193e754814490ee" + " " + " d-flex justify-content-center align-self-center giveassured-image-panel",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "".concat(giveAssuredPanel_config.cdnUrl).concat(imageUrl),
                                    alt: "give assured panel image",
                                    align: "middle",
                                    style: {
                                        height: '250px'
                                    },
                                    className: "jsx-3193e754814490ee"
                                })
                            })
                        })
                    })
                ]
            }),
            _jsx(_JSXStyle, {
                id: "3193e754814490ee",
                children: ".gi-giveassured-panel{overflow:hidden;\nborder-radius:10px;\nbox-shadow:none;\nborder:none;\nbackground-color:#f2f2f2}\n.giveassured-text-panel{padding:2rem 2rem 1rem 2rem}\n.giveassured-image-panel{padding:1rem 0rem 1rem 0rem}\n@media (max-width:768px) {.giveassured-text-panel{padding:1.5rem 0rem 1rem 0rem}}"
            })
        ]
    }));
};
/* harmony default export */ var giveAssuredPanel = ((/* unused pure expression or super */ null && (GiveAssuredPanel)));

// EXTERNAL MODULE: ./components/chrome/elements/panels/giveFeatures/index.js
var giveFeatures = __webpack_require__(62810);
// EXTERNAL MODULE: ./components/chrome/elements/cards/imageCard/index.js
var imageCard = __webpack_require__(39621);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/imagePanel/index.js







function imagePanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function imagePanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            imagePanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var createImages = function(images, panelName) {
    return images.map(function(image, index) {
        /*#__PURE__*/ return (0,react.createElement)(imageCard/* default */.Z, imagePanel_objectSpread({}, image, {
            key: index,
            clickHandler: function(e) {
                return panels_onClickHandle(e, 'image-panel-click', {
                    index: index,
                    panelName: panelName
                }, image.link);
            }
        }));
    });
};
var ImagePanel = function(param) {
    var images = param.images, panelName = param.panelName, heading = param.heading;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: [
            typeof heading !== 'undefined' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: heading
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                className: "d-flex remove-margin justify-content-center m-image-panel-container",
                children: createImages(images, panelName)
            })
        ]
    });
};
ImagePanel.defaultProps = {
    panelName: 'panel',
    className: 'd-flex justify-content-center',
    images: [
        {
            src: {
                mobile: 'https://cdn.givind.org/static/banner1.jpg',
                desktop: 'https://s3.ap-south-1.amazonaws.com/give-marketplace-dev/static/images/wg/ola/BANNER-Ola.jpg'
            },
            alt: 'Banner 1',
            className: 'image-w-58',
            style: {},
            link: 'https://docs.google.com/document/d/1outz6Xq3uIuQIpg9UZsI37oLZK9zK3o-55ZHSxxli1U/edit'
        }
    ]
};
/* harmony default export */ var imagePanel = ((0,react_contextual_es/* subscribe */.Ld)()(ImagePanel));

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./components/common/renderByDeviceType.js
var renderByDeviceType = __webpack_require__(54868);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/carouselPanel/index.js







function carouselPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function carouselPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function carouselPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function carouselPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) carouselPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) carouselPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function carouselPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carouselPanel_getPrototypeOf(o) {
    carouselPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return carouselPanel_getPrototypeOf(o);
}
function carouselPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) carouselPanel_setPrototypeOf(subClass, superClass);
}
function carouselPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carouselPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function carouselPanel_possibleConstructorReturn(self, call) {
    if (call && (carouselPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return carouselPanel_assertThisInitialized(self);
}
function carouselPanel_setPrototypeOf(o, p) {
    carouselPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return carouselPanel_setPrototypeOf(o, p);
}
var carouselPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function carouselPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function carouselPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = carouselPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = carouselPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = carouselPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return carouselPanel_possibleConstructorReturn(this, result);
    };
}
var CarouselPanel = // import CovidModal from '../../modal/covidModal';
/*#__PURE__*/ function(Component1) {
    "use strict";
    carouselPanel_inherits(CarouselPanel, Component1);
    var _super = carouselPanel_createSuper(CarouselPanel);
    function CarouselPanel(props) {
        carouselPanel_classCallCheck(this, CarouselPanel);
        return _super.call(this, props);
    }
    carouselPanel_createClass(CarouselPanel, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                var items = this.props.items;
                var sliderSettings = {
                    arrows: true,
                    dots: true,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 1,
                    slidesToScroll: 1
                };
                var slides = items.map(function(item, index) {
                    var mobileStartUtm = item.mobile_link && item.mobile_link.indexOf('?utm_source') - 1;
                    var desktopStartUtm = item.desktop_link && item.desktop_link.indexOf('?utm_source') - 1;
                    var linkStartUtm = item.link && item.link.indexOf('?utm_source') - 1;
                    var mobile_link = (mobileStartUtm > -1 ? item.mobile_link.substring(0, mobileStartUtm) : item.mobile_link) || (linkStartUtm > -1 ? item.link.substring(0, linkStartUtm) : item.link);
                    var desktop_link = (desktopStartUtm > -1 ? item.desktop_link.substring(0, desktopStartUtm) : item.desktop_link) || (linkStartUtm > -1 ? item.link.substring(0, linkStartUtm) : item.link);
                    var mobile = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: mobile_link,
                        onClick: function(e) {
                            return panels_onClickHandle(e, 'carousel click', {
                                link: JSON.stringify(mobile_link),
                                name: item.altText
                            }, mobile_link);
                        },
                        children: _this.props.AB && _this.props.AB.varients && _this.props.AB.varients['homepage'] === 'a' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "pointer w-100",
                            src: item.src.mobile,
                            alt: item.altText,
                            loading: "lazy"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "pointer w-100",
                            src: item.src.mobile,
                            alt: item.altText,
                            loading: "lazy"
                        })
                    });
                    var desktop = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: desktop_link,
                        onClick: function(e) {
                            return panels_onClickHandle(e, 'carousel click', {
                                link: JSON.stringify(desktop_link),
                                name: item.altText
                            }, desktop_link);
                        },
                        children: _this.props.AB && _this.props.AB.varients && _this.props.AB.varients['homepage'] === 'a' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "pointer w-100",
                            src: item.src.desktop,
                            alt: item.altText,
                            loading: "lazy"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "pointer w-100",
                            src: item.src.desktop,
                            alt: item.altText,
                            loading: "lazy"
                        })
                    });
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(renderByDeviceType/* default */.Z, {
                            mobile: mobile,
                            desktop: desktop
                        })
                    }, index));
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-c14247408c3827d6" + " " + "d-flex w-100 home-paeg-carousel-arrow justify-content-center homepage-carousel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, carouselPanel_objectSpread({}, sliderSettings, {
                                children: slides
                            }))
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "c14247408c3827d6",
                            children: ".homepage-carousel .slick-slider{width:100%}\n.homepage-carousel .pointer{cursor:pointer}\n.homepage-carousel .slick-dots{bottom:20px}\n.homepage-carousel .slick-dots li button:before{font-size:3rem}\n.slick-next{right:25px}\n.slick-prev{left:25px}\n.home-paeg-carousel-arrow .slick-next, .home-paeg-carousel-arrow .slick-prev{background-repeat:no-repeat;\nheight:80px}\n.home-paeg-carousel-arrow .slick-next{right:2rem;\nbackground-image:url('https://give-marketplace.s3.ap-south-1.amazonaws.com/static/icons/program-page/right-arrow.svg')}\n.home-paeg-carousel-arrow .slick-prev{left:2rem;\nz-index:1!important;\nbackground-image:url('https://give-marketplace.s3.ap-south-1.amazonaws.com/static/icons/program-page/left-arrow.svg')}\n.home-paeg-carousel-arrow .slick-prev.slick-disabled, .home-paeg-carousel-arrow .slick-next.slick-disabled{background-image:none}\n.home-paeg-carousel-arrow .slick-next:before{content:'';\ncolor:black}\n.home-paeg-carousel-arrow .slick-prev:before{content:'';\ncolor:black}\n@media (max-width:768px) {.home-paeg-carousel-arrow .slick-next{display:none!important}\n.home-paeg-carousel-arrow .slick-prev{display:none!important}}"
                        })
                    ]
                }));
            }
        }
    ]);
    return CarouselPanel;
}(react.Component);
/* harmony default export */ var carouselPanel = ((0,react_contextual_es/* subscribe */.Ld)()(CarouselPanel));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/locationPanel/locationBlock.js






var getImages = function(margin, imageProps) {
    var classCol = margin == true ? 'gi-location-card default d-flex justify-content-center ' : 'gi-location-card no-padding d-flex justify-content-center ';
    if (imageProps.length > 2) {
        var stackClass = "stack-".concat(imageProps.length);
        classCol += stackClass;
    }
    return imageProps.map(function(item, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            className: classCol,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: item.link,
                onClick: function(e) {
                    return panels_onClickHandle(e, 'location-panel-click', {
                        index: index,
                        location: item.location
                    }, item.link);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_responsive_default()), {
                        query: "(max-width: 576px)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            className: "d-flex align-self-center py-3",
                            style: {
                                margin: '0 auto !important'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "grid-image align-self-center location-panel",
                                    src: item.imageMobile,
                                    alt: item[index]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                    sm: "12",
                                    xs: "12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "main-heading",
                                            children: item.location
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "sub-heading",
                                            children: item.subHeading
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_responsive_default()), {
                        query: "(min-width: 576px)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            className: "d-flex align-self-center py-3 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "grid-image align-self-center location-panel",
                                    src: item.image,
                                    alt: item[index]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                    sm: "12",
                                    xs: "12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "main-heading",
                                            children: item.location
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "sub-heading",
                                            children: item.subHeading
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        }, index);
    });
};
var LocationBlock = function(param) {
    var className = param.className, style = param.style, margin = param.margin, imageProps = param.imageProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
        className: "d-flex remove-margin justify-content-center",
        children: getImages(margin, imageProps)
    });
};
LocationBlock.defaultProps = {
    margin: true,
    title: 'empower women to fight back',
    className: 'd-flex justify-content-center location-panel',
    imageProps: [
        {
            image: '/static/images/delhi.png',
            imageMobile: '/static/images/delhi.png',
            location: 'Delhi',
            subHeading: '52 programs',
            link: '/search?tag=New%20Delhi&type=relevance'
        },
        {
            image: '/static/images/maharashtra.png',
            imageMobile: '/static/images/maharashtra.png',
            location: 'Maharashtra',
            subHeading: '52 programs',
            link: '/search?tag=Maharashtra&type=relevance'
        },
        {
            image: '/static/images/karnataka.png',
            imageMobile: '/static/images/karnataka.png',
            location: 'Karnataka',
            subHeading: '52 programs',
            link: '/search?tag=Karnataka&type=relevance'
        },
        {
            image: '/static/images/odisha.png',
            imageMobile: '/static/images/odisha.png',
            location: 'Odisha',
            subHeading: '152 programs',
            link: '/search?tag=Odisha&type=relevance'
        },
        {
            image: '/static/images/rajasthan.png',
            imageMobile: '/static/images/rajasthan.png',
            location: 'Rajasthan',
            subHeading: '52 programs',
            link: '/search?tag=Rajasthan&type=relevance'
        }, 
    ]
};
/* harmony default export */ var locationBlock = ((0,react_contextual_es/* subscribe */.Ld)()(LocationBlock));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/locationPanel/index.js





function locationPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function locationPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            locationPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var LocationPanel = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
        className: "gi-location-panel panel-padding",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(locationBlock, locationPanel_objectSpread({
            className: "gi-imagepanel"
        }, props))
    });
};
/* harmony default export */ var locationPanel = ((0,react_contextual_es/* subscribe */.Ld)()(LocationPanel));

// EXTERNAL MODULE: ./components/chrome/elements/panels/programPanel/index.js
var programPanel = __webpack_require__(13433);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/tagsPanel/tagBlock.js






var getTags = function(tags) {
    var classCol = 'default tag-block d-flex justify-content-center mb-3 mobile-ls-w-50 ';
    if (tags.length > 2) {
        var stackClass = "stack-".concat(tags.length);
        classCol += stackClass;
    }
    return tags.map(function(item, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            className: classCol,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: item.link,
                className: "no-hover no-underline",
                onClick: function(e) {
                    return panels_onClickHandle(e, 'tag-panel-click', {
                        index: index,
                        tag: item.tag
                    }, item.link);
                },
                style: {
                    width: '100%'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex tag-block-wrapper text-center p-3 h-100",
                    style: {
                        width: '100%',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_tag/* default */.Z, {
                            design: "capsule",
                            tag: item.tag,
                            className: "align-self-center",
                            style: {
                                fontSize: '14px',
                                marginBottom: '0.5rem'
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tags-description d-flex",
                            children: item.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn btn-outline-dark",
                            children: "View All"
                        })
                    ]
                })
            })
        }, item.tag);
    });
};
var TagsBlock = function(param) {
    var tags = param.tags;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
        children: getTags(tags)
    });
};
TagsBlock.defaultProps = {
    className: 'd-flex justify-content-center image-mw-50'
};
/* harmony default export */ var tagBlock = ((0,react_contextual_es/* subscribe */.Ld)()(TagsBlock));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/tagsPanel/index.js





var TagsPanel = function(param) {
    var tags = param.tags;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
            className: "d-flex gi-tagspanel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tagBlock, {
                tags: tags,
                className: "gi-tagspanel"
            })
        })
    });
};
/* harmony default export */ var tagsPanel = ((0,react_contextual_es/* subscribe */.Ld)()(TagsPanel));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/testimonialPanel/index.js




var testimonialPanel_config = (0,config["default"])().publicRuntimeConfig;
var TestimonialPanel = function(param) {
    var title = param.title, programs = param.programs, viewAll = param.viewAll;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                    md: "7",
                    sm: "12",
                    xs: "12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(testimonialPanel_config.cdnUrl, "/static/quotes1.png"),
                            className: "testimonial-quotes"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "testimonial-text",
                            children: "I am extremely pleased to see GiveIndia’s new platform which has an enhanced marketplace and an improved user experience."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(testimonialPanel_config.cdnUrl, "/static/quotes.png"),
                            className: "testimonial-quotes bottom-quote"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                    md: "5",
                    sm: "12",
                    xs: "12",
                    style: {
                        paddingLeft: '4rem',
                        paddingRight: '4rem',
                        paddingTop: '40px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(testimonialPanel_config.cdnUrl, "/static/testimonial-photo.jpg"),
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                margin: '0',
                                paddingTop: '0.5rem'
                            },
                            children: "Sandeep Sibal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "CEO & Co-Founder, Fourth Frontier"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonialPanel = (TestimonialPanel);

// EXTERNAL MODULE: ./components/chrome/elements/panels/newsletterPanel/index.js
var newsletterPanel = __webpack_require__(78970);
// EXTERNAL MODULE: ./node_modules/react-waypoint/es/index.js + 1 modules
var es = __webpack_require__(83824);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/impactCard/index.js







function impactCard_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function impactCard_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function impactCard_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function impactCard_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) impactCard_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) impactCard_defineProperties(Constructor, staticProps);
    return Constructor;
}
function impactCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function impactCard_getPrototypeOf(o) {
    impactCard_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return impactCard_getPrototypeOf(o);
}
function impactCard_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) impactCard_setPrototypeOf(subClass, superClass);
}
function impactCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            impactCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function impactCard_possibleConstructorReturn(self, call) {
    if (call && (impactCard_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return impactCard_assertThisInitialized(self);
}
function impactCard_setPrototypeOf(o, p) {
    impactCard_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return impactCard_setPrototypeOf(o, p);
}
var impactCard_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function impactCard_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function impactCard_createSuper(Derived) {
    var hasNativeReflectConstruct = impactCard_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = impactCard_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = impactCard_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return impactCard_possibleConstructorReturn(this, result);
    };
}
var impactCard_config = (0,config["default"])().publicRuntimeConfig;
var items = [
    {
        src: "".concat(impactCard_config.cdnUrl, "/static/images/home/sustained-impact-desktop-card.jpg"),
        name: 'Sustained change',
        bgsrc: "".concat(impactCard_config.cdnUrl, "/static/images/home/sustained-impact-card.svg"),
        text: ' Help build a better future for the poor'
    },
    {
        src: "".concat(impactCard_config.cdnUrl, "/static/images/home/deeper-engagement-desktop-card.jpg"),
        name: 'Engage deeply',
        bgsrc: "".concat(impactCard_config.cdnUrl, "/static/images/home/deeper-engagement-card.svg"),
        text: 'Stay connected with the lives you impact'
    },
    {
        src: "".concat(impactCard_config.cdnUrl, "/static/images/home/big-impact-desktop-card.jpg"),
        name: 'Big impact',
        bgsrc: "".concat(impactCard_config.cdnUrl, "/static/images/home/big-impact-card.svg"),
        text: 'Small monthly donations lead to large scale impact'
    }, 
];
var settingsSlider = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 1.1,
    slidesToScroll: 1
};
var ImpactCard = /*#__PURE__*/ function(Component1) {
    "use strict";
    impactCard_inherits(ImpactCard, Component1);
    var _super = impactCard_createSuper(ImpactCard);
    function ImpactCard(props) {
        impactCard_classCallCheck(this, ImpactCard);
        var _this;
        _this = _super.call(this, props);
        impactCard_defineProperty(impactCard_assertThisInitialized(_this), "_handleWaypointEnter", function() {
            _this.setState({
                visible: true
            });
        });
        impactCard_defineProperty(impactCard_assertThisInitialized(_this), "impactCardPanel", function(items1) {
            return items1.map(function(item, idx) {
                var isVisible = _this.state.visible;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                    xs: "12",
                    sm: "12",
                    md: "4",
                    lg: "4",
                    /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card impact-card",
                        children: [
                            isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "card-img-top",
                                src: item.src,
                                alt: "Card image cap"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "centered justify-content-center align-self-center w-100 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    style: {
                                        color: 'white'
                                    },
                                    children: item.name
                                })
                            }),
                            isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "centered-image-on-background image-bg-impact",
                                    src: item.bgsrc,
                                    alt: "Card image cap"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "centered-text-on-background text-center ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "justify-content-center align-self-center ",
                                    children: [
                                        item.text,
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                }, idx));
            });
        });
        _this.state = {
            visible: false
        };
        return _this;
    }
    impactCard_createClass(ImpactCard, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
                            onEnter: this._handleWaypointEnter,
                            bottomOffset: -300
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-1ba371a6701aa97a",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-1ba371a6701aa97a",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                        style: {
                                            paddingLeft: '15px'
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            style: {
                                                marginBottom: '2rem'
                                            },
                                            className: "jsx-1ba371a6701aa97a" + " " + "mr-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        color: this.props.theme.primaryColor
                                                    },
                                                    className: "jsx-1ba371a6701aa97a",
                                                    children: "Monthly giving"
                                                }),
                                                ' ',
                                                "helps you commit to long term change"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                    className: "impact-card-on-desktop",
                                    children: this.impactCardPanel(items)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-1ba371a6701aa97a" + " " + "impact-card-on-mobile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, impactCard_objectSpread({}, settingsSlider, {
                                        className: "",
                                        children: this.impactCardPanel(items)
                                    }))
                                }),
                                (0,jsx_runtime.jsx)((style_default()), {
                                    id: "1ba371a6701aa97a",
                                    children: ".impact-card{border-radius:10px}\n@media (max-width:768px) {.impact-card-on-mobile{display:block}\n.impact-card-on-desktop{display:none}\n.slick-track{margin-left:0!important}}\n@media (min-width:768px) {.impact-card-on-mobile{display:none}\n.impact-card-on-desktop{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex}}\n.image-bg-impact{height:65px;\nopacity:0.8}\n.centered-text-on-background{position:absolute;\ntop:65%;\nfont-size:16px;\nbottom:0px;\nleft:37%;\n-webkit-transform:translate(-50%, -50%);\n-moz-transform:translate(-50%, -50%);\n-ms-transform:translate(-50%, -50%);\ntransform:translate(-50%, -50%);\npadding:0px 3rem 1.5rem 3rem;\ncolor:white}\n.centered-image-on-background{position:absolute;\ntop:24%;\nleft:50%;\n-webkit-transform:translate(-50%, -50%);\n-moz-transform:translate(-50%, -50%);\n-ms-transform:translate(-50%, -50%);\ntransform:translate(-50%, -50%);\ncolor:white}\n.centered{position:absolute;\ntop:50%;\nleft:37%;\n-webkit-transform:translate(-50%, -50%);\n-moz-transform:translate(-50%, -50%);\n-ms-transform:translate(-50%, -50%);\ntransform:translate(-50%, -50%);\ncolor:white}\n.card-img-top{border-radius:6px}"
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return ImpactCard;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/elements/panels/programHighlightPanel/index.js








function programHighlightPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function programHighlightPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            programHighlightPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var programHighlightPanel_config = (0,config["default"])().publicRuntimeConfig;
var ProgramHighlightPanel = function(param) {
    var className = param.className, heading = param.heading, nonprofit = param.nonprofit, description = param.description, needed = param.needed, completed = param.completed, size = param.size, image1 = param.image1, tags = param.tags, partnerImage = param.partnerImage, link = param.link;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, programHighlightPanel_objectSpread({}, size.left, {
                    className: "gi-campaign-image d-flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(programHighlightPanel_config.cdnUrl).concat(image1),
                            alt: heading,
                            className: "gi-background-image"
                        }),
                        partnerImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "partner-ngo-image",
                            src: "".concat(programHighlightPanel_config.cdnUrl).concat(partnerImage),
                            alt: heading
                        })
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, programHighlightPanel_objectSpread({}, size.right, {
                    className: "gi-campaign-textbox d-flex justify-content-between f-d-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "campaign-panel-top",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tag-row",
                                    children: typeof tags !== 'undefined' ? tags.map(function(tag, index) {
                                        /*#__PURE__*/ return (0,react.createElement)(elements_tag/* default */.Z, programHighlightPanel_objectSpread({}, tag, {
                                            key: index
                                        }));
                                    }) : []
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "by ".concat(nonprofit)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "progress-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: link,
                                onClick: function(e) {
                                    return panels_onClickHandle(e, 'campaign-givenow-click', {
                                        heading: heading,
                                        link: link
                                    }, link);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    className: "btn-full-width campaign-panel-givenow",
                                    children: "give now"
                                })
                            })
                        })
                    ]
                }))
            ]
        })
    });
};
ProgramHighlightPanel.defaultProps = {
    className: 'gi-campaign-panel d-flex',
    heading: 'Help underprivileged women earn a living',
    nonprofit: 'Ola Foundation',
    description: 'Ola Foundation works towards skilling women women to earn an income, teach them financial literacy to save more money and equipping them with emotional intelligence to better manage their hardships in life.',
    size: {
        left: {
            xs: 12,
            sm: 12,
            md: '7',
            lg: '7',
            xl: '7'
        },
        right: {
            xs: 12,
            sm: 12,
            md: '5',
            lg: '5',
            xl: '5'
        }
    },
    tags: [
        {
            type: 'extremeneed',
            design: 'capsule'
        }, 
    ],
    image1: '/static/images/home/ola/ola-help-underprivileged-women-earn-a-living.jpg',
    partnerImage: '',
    link: '/program/Empower-Women-to-Build-a-Better-Future'
};
/* harmony default export */ var programHighlightPanel = ((0,react_contextual_es/* subscribe */.Ld)()(ProgramHighlightPanel));

// EXTERNAL MODULE: ./components/workplace/common/selectByPlatform.js
var selectByPlatform = __webpack_require__(93220);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/videoPanel/index.js







function videoPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function videoPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function videoPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function videoPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) videoPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) videoPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function videoPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function videoPanel_getPrototypeOf(o) {
    videoPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return videoPanel_getPrototypeOf(o);
}
function videoPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) videoPanel_setPrototypeOf(subClass, superClass);
}
function videoPanel_possibleConstructorReturn(self, call) {
    if (call && (videoPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return videoPanel_assertThisInitialized(self);
}
function videoPanel_setPrototypeOf(o, p) {
    videoPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return videoPanel_setPrototypeOf(o, p);
}
var videoPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function videoPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function videoPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = videoPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = videoPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = videoPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return videoPanel_possibleConstructorReturn(this, result);
    };
}
var videoPanel_config = (0,config["default"])().publicRuntimeConfig;
var VideoPanel = /*#__PURE__*/ function(Component1) {
    "use strict";
    videoPanel_inherits(VideoPanel, Component1);
    var _super = videoPanel_createSuper(VideoPanel);
    function VideoPanel(props) {
        videoPanel_classCallCheck(this, VideoPanel);
        var _this;
        _this = _super.call(this, props);
        videoPanel_defineProperty(videoPanel_assertThisInitialized(_this), "_handleWaypointEnter", function() {
            _this.setState({
                loadVideo: true
            });
        });
        _this.state = {
            loadVideo: false
        };
        return _this;
    }
    videoPanel_createClass(VideoPanel, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    className: "panel-padding",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
                            onEnter: this._handleWaypointEnter,
                            bottomOffset: -200
                        }),
                        this.state.loadVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(selectByPlatform/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    name: "www",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                                            className: "align-items-stretch video-panel-row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                    xs: "12",
                                                    md: "6",
                                                    lg: "6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "jsx-e6a15e0aa6971753" + " " + "video-responsive",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                            width: "853",
                                                            height: "480",
                                                            src: this.props.videoUrl,
                                                            frameborder: "0",
                                                            allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                                            allowfullscreen: true,
                                                            className: "jsx-e6a15e0aa6971753"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                    xs: "12",
                                                    md: "6",
                                                    lg: "6",
                                                    className: "home-page-why-giveindia-panel",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "jsx-e6a15e0aa6971753" + " " + "video-panel-right-side-panel",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-e6a15e0aa6971753",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "jsx-e6a15e0aa6971753",
                                                                        children: "GiveIndia is India's most trusted donations platform"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "jsx-e6a15e0aa6971753",
                                                                        children: "Sign up for monthly donations on GiveIndia and create a long-lasting impact on the lives of the poor in India"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-e6a15e0aa6971753",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "jsx-e6a15e0aa6971753",
                                                                        children: "Why GiveIndia?"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "jsx-e6a15e0aa6971753",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                                                                                className: "d-flex why-giveindia-panel-for-mobile",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                                                                        sm: "6",
                                                                                        xs: "6",
                                                                                        md: "6",
                                                                                        lg: "6",
                                                                                        className: "p-0",
                                                                                        style: {
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: "".concat(videoPanel_config.cdnUrl, "/static/icons/gi_TRUST.svg"),
                                                                                                alt: "convenient setup",
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "program-page-bitmap"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "why-monthly-giving-box-text",
                                                                                                children: "High trust"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                                                                        sm: "6",
                                                                                        xs: "6",
                                                                                        md: "6",
                                                                                        lg: "6",
                                                                                        className: "",
                                                                                        style: {
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: "".concat(videoPanel_config.cdnUrl, "/static/icons/gi_CONVENIENCE.svg"),
                                                                                                alt: "Long-term impact",
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "program-page-bitmap"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "why-monthly-giving-box-text",
                                                                                                children: "Convenience"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                                                                                className: "why-giveindia-panel-for-mobile",
                                                                                style: {
                                                                                    paddingBottom: '1rem',
                                                                                    paddingTop: '1rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                                                                        sm: "6",
                                                                                        xs: "6",
                                                                                        md: "6",
                                                                                        lg: "6",
                                                                                        className: "p-0",
                                                                                        style: {
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                style: {
                                                                                                    whiteSpace: 'nowrap'
                                                                                                },
                                                                                                src: "".concat(videoPanel_config.cdnUrl, "/static/icons/gi_TAX.svg"),
                                                                                                alt: "Deep Engagement",
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "program-page-bitmap"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "why-monthly-giving-box-text",
                                                                                                children: "Tax exemption"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                                                                        sm: "6",
                                                                                        xs: "6",
                                                                                        md: "6",
                                                                                        lg: "6",
                                                                                        style: {
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: "".concat(videoPanel_config.cdnUrl, "/static/icons/gi_REPORT.svg"),
                                                                                                alt: "High commitment",
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "program-page-bitmap"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "jsx-e6a15e0aa6971753" + " " + "why-monthly-giving-box-text",
                                                                                                children: "Regular report"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        (0,jsx_runtime.jsx)((style_default()), {
                                            id: "e6a15e0aa6971753",
                                            children: ".video-panel-row{border:1px solid rgba(0, 0, 0, 0.1)}\n.video-responsive{overflow:hidden;\npadding-bottom:56.25%;\nposition:relative;\nheight:0}\n.video-responsive iframe{left:0;\ntop:0;\nheight:100%;\nwidth:100%;\nposition:absolute}\n.why-monthly-giving-box-text{display:inline;\npadding-left:10px;\ncolor:#444444;\nwhite-space:nowrap;\nmargin-bottom:0px}\n.home-page-why-giveindia-panel{padding:1rem 2rem 1rem 2rem;\nborder:none;\nborder-radius:4px;\nbox-shadow:none}\n@media (max-width:768px) {.home-page-why-giveindia-panel{padding:16px 15px 0 15px;\nborder:none;\nborder-radius:none;\nbox-shadow:none}}\n@media (max-width:768px) {.why-giveindia-panel-for-mobile{}}"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    name: "wg"
                                })
                            ]
                        }) : null
                    ]
                }));
            }
        }
    ]);
    return VideoPanel;
}(react.Component);


// EXTERNAL MODULE: ./components/chrome/elements/cards/beneficiaryProgramCard.js
var beneficiaryProgramCard = __webpack_require__(75217);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/beneficiaryPanel/index.js







function beneficiaryPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function beneficiaryPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function beneficiaryPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function beneficiaryPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) beneficiaryPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) beneficiaryPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function beneficiaryPanel_getPrototypeOf(o) {
    beneficiaryPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return beneficiaryPanel_getPrototypeOf(o);
}
function beneficiaryPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) beneficiaryPanel_setPrototypeOf(subClass, superClass);
}
function beneficiaryPanel_possibleConstructorReturn(self, call) {
    if (call && (beneficiaryPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return beneficiaryPanel_assertThisInitialized(self);
}
function beneficiaryPanel_setPrototypeOf(o, p) {
    beneficiaryPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return beneficiaryPanel_setPrototypeOf(o, p);
}
var beneficiaryPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function beneficiaryPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function beneficiaryPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = beneficiaryPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = beneficiaryPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = beneficiaryPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return beneficiaryPanel_possibleConstructorReturn(this, result);
    };
}
var beneficiaryPanel_config = (0,config["default"])().publicRuntimeConfig;
var BeneficiaryPanel = /*#__PURE__*/ function(Component1) {
    "use strict";
    beneficiaryPanel_inherits(BeneficiaryPanel, Component1);
    var _super = beneficiaryPanel_createSuper(BeneficiaryPanel);
    function BeneficiaryPanel(props) {
        beneficiaryPanel_classCallCheck(this, BeneficiaryPanel);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            loadVideo: false
        };
        return _this;
    }
    beneficiaryPanel_createClass(BeneficiaryPanel, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, title = _props.title, programs = _props.programs, viewAll = _props.viewAll, session = _props.session, width = _props.width, theme = _props.theme;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    className: "panel-padding",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "6",
                                    className: "p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        style: {
                                            marginBottom: '2rem'
                                        },
                                        className: "jsx-daea7e35f816418d",
                                        children: [
                                            "Support a beneficiary directly",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(beneficiaryPanel_config.cdnUrl, "/static/images/home/homepage-new-badge.svg"),
                                                alt: "",
                                                className: "jsx-daea7e35f816418d" + " " + "hide-for-mobile homepage-new-start-image"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "6",
                                    style: {
                                        textAlign: 'right'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: viewAll,
                                        style: {
                                            fontSize: '0.875rem',
                                            color: '#444444'
                                        },
                                        className: "jsx-daea7e35f816418d" + " " + "ml-auto no-hover-a hide-for-mobile",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    paddingRight: '6px'
                                                },
                                                onClick: function() {
                                                    if (window.eventDispatcher) {
                                                        window.eventDispatcher.dispatchEvent('beneficiary-panel-viewAll', {}, {
                                                            amplitude: true
                                                        });
                                                    }
                                                },
                                                className: "jsx-daea7e35f816418d" + " " + " viewall-for-mobile",
                                                children: "View All"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrowSmall/* default */.Z, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                            children: programs.map(function(program, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(beneficiaryProgramCard/* default */.Z, {
                                    program: program,
                                    position: index + 1,
                                    session: session,
                                    lazyLoadImage: true,
                                    theme: theme
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: viewAll,
                                style: {
                                    fontSize: '0.875rem',
                                    color: '#444444'
                                },
                                className: "jsx-daea7e35f816418d" + " " + "ml-auto no-hover-a hide-for-desktop",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            paddingRight: '6px'
                                        },
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEvent('beneficiary-panel-viewAll', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        className: "jsx-daea7e35f816418d" + " " + " viewall-for-mobile",
                                        children: "View All"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrowSmall/* default */.Z, {})
                                ]
                            })
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "daea7e35f816418d",
                            children: ".beneficiary-panel-icon{height:21px}\n.homepage-new-start-image{height:1.5rem;\npadding-left:1rem}\n@media (max-width:768px) {.viewall-for-mobile{padding-bottom:1rem!important}}"
                        })
                    ]
                }));
            }
        }
    ]);
    return BeneficiaryPanel;
}(react.Component);


// EXTERNAL MODULE: ./components/chrome/elements/panels/ctaPanel/index.js
var ctaPanel = __webpack_require__(51076);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Media.js
var Media = __webpack_require__(34726);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/donorBenfits/index.js





function donorBenfits_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function donorBenfits_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function donorBenfits_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function donorBenfits_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) donorBenfits_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) donorBenfits_defineProperties(Constructor, staticProps);
    return Constructor;
}
function donorBenfits_getPrototypeOf(o) {
    donorBenfits_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return donorBenfits_getPrototypeOf(o);
}
function donorBenfits_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) donorBenfits_setPrototypeOf(subClass, superClass);
}
function donorBenfits_possibleConstructorReturn(self, call) {
    if (call && (donorBenfits_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return donorBenfits_assertThisInitialized(self);
}
function donorBenfits_setPrototypeOf(o, p) {
    donorBenfits_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return donorBenfits_setPrototypeOf(o, p);
}
var donorBenfits_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function donorBenfits_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function donorBenfits_createSuper(Derived) {
    var hasNativeReflectConstruct = donorBenfits_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = donorBenfits_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = donorBenfits_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return donorBenfits_possibleConstructorReturn(this, result);
    };
}
var donorBenfits_config = (0,config["default"])().publicRuntimeConfig;
var mediaMainBody = {
    paddingLeft: '5px',
    paddingTop: '4px',
    fontSize: '0.9rem'
};
var mediaImage = {
    marginTop: '0.5rem'
};
var outerBox = {
    padding: '0 1rem 1rem'
};
var mediaMainHeading = {
    fontWeight: '600',
    marginBottom: '0'
};
var DonorBenfits = /*#__PURE__*/ function(_Component) {
    "use strict";
    donorBenfits_inherits(DonorBenfits, _Component);
    var _super = donorBenfits_createSuper(DonorBenfits);
    function DonorBenfits(props) {
        donorBenfits_classCallCheck(this, DonorBenfits);
        var _this;
        _this = _super.call(this, props);
        _this.state = {};
        return _this;
    }
    donorBenfits_createClass(DonorBenfits, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    style: {
                        marginBottom: '24px',
                        marginTop: '20px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            style: {
                                paddingBottom: '0rem'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "3",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    style: outerBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-36041e3e3ec0ee6b" + " " + "d-flex  align-self-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    left: true,
                                                    top: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(donorBenfits_config.cdnUrl, "/static/images/home/homev2/beneficiary-v4.png"),
                                                        width: "50",
                                                        height: "50",
                                                        style: mediaImage,
                                                        alt: "money-raised",
                                                        loading: "lazy",
                                                        className: "jsx-36041e3e3ec0ee6b" + " " + "donor-benfits-image"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    body: true,
                                                    style: mediaMainBody,
                                                    className: "donor-benfit-for-mobile",
                                                    children: "Know your beneficiary, we'll share their name, picture and more"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "3",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    style: outerBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-36041e3e3ec0ee6b" + " " + "d-flex  align-self-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    left: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(donorBenfits_config.cdnUrl, "/static/images/home/homev2/change-lives-v4.png"),
                                                        width: "50",
                                                        height: "50",
                                                        style: mediaImage,
                                                        alt: "donors-icon",
                                                        loading: "lazy",
                                                        className: "jsx-36041e3e3ec0ee6b"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    body: true,
                                                    style: mediaMainBody,
                                                    className: "donor-benfit-for-mobile",
                                                    children: "Learn how you make a change in their lives through our reports"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "3",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    style: outerBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-36041e3e3ec0ee6b" + " " + "d-flex  align-self-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    left: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(donorBenfits_config.cdnUrl, "/static/images/home/homev2/give-assuredv4.png"),
                                                        width: "50",
                                                        height: "50",
                                                        style: mediaImage,
                                                        alt: "lives-impacted-icon",
                                                        loading: "lazy",
                                                        className: "jsx-36041e3e3ec0ee6b"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    body: true,
                                                    style: mediaMainBody,
                                                    className: "donor-benfit-for-mobile",
                                                    children: "Every beneficiary you support is under the care of GiveAssured nonprofits"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "3",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    style: outerBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-36041e3e3ec0ee6b" + " " + "d-flex  align-self-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                                    left: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(donorBenfits_config.cdnUrl, "/static/images/home/homev2/monthly-giving-v4.png"),
                                                        width: "50",
                                                        height: "50",
                                                        style: mediaImage,
                                                        alt: "trusted-icon",
                                                        loading: "lazy",
                                                        className: "jsx-36041e3e3ec0ee6b"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                                                    body: true,
                                                    style: mediaMainBody,
                                                    className: "donor-benfit-for-mobile",
                                                    children: [
                                                        "Your choice to give monthly will make a long-lasting impact",
                                                        ' '
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "36041e3e3ec0ee6b",
                            children: ".sub-divider-heading{border-bottom:3px solid #ff5050;\nwidth:50px;\nmargin:0 auto 15px}\n.donor-benfits-image{width:51px;\nheight:52px}\n.monthly-mission-heading{font-size:1.5rem;\ntext-align:center}\n@media (max-width:768px) {.donor-benfits-on-mobile{padding-bottom:1rem}\n.donor-benfit-for-mobile{padding-top:1rem!important;\npadding-left:2rem!important}}"
                        })
                    ]
                }));
            }
        }
    ]);
    return DonorBenfits;
}(react.Component);
/* harmony default export */ var donorBenfits = (DonorBenfits);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/giveAssuredPanelNew/index.js





// import './giveAssuredPanel.scss';
var giveAssuredPanelNew_config = (0,config["default"])().publicRuntimeConfig;
var giveAssuredPanelNew_items = [
    {
        src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/homev2/money-raised-icon.svg"),
        totalNumber: ' 700cr+',
        desc: 'raised for nonprofits'
    },
    {
        src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/homev2/donors-icon.svg"),
        totalNumber: '2M+',
        desc: 'donors have contributed to causes'
    },
    {
        src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/homev2/lives-impacted-icon.svg"),
        totalNumber: '15M+',
        desc: 'lives impacted'
    },
    {
        src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/homev2/trusted-icon.svg"),
        totalNumber: 'Trusted',
        desc: 'by 150+ corporates and brands'
    }
];
var giveAssuredPanelNew_mediaMainBody = {
    paddingLeft: '1rem',
    fontWeight: '300',
    fontSize: '0.875rem'
};
var giveAssuredPanelNew_mediaImage = {
    marginTop: '0.5rem'
};
var giveAssuredPanelNew_outerBox = {
    paddingBottom: 0,
    paddingTop: '2rem'
};
var giveAssuredPanelNew_mediaMainHeading = {
    fontWeight: '600',
    marginBottom: '0'
};
var mediaMainHeadings = {
    fontWeight: '600',
    marginBottom: '0',
    color: '#FF5050'
};
var GiveAssuredPanelNew = function() {
    var giveassuredDetails = giveAssuredPanelNew_items.map(function(item, indexg) {
        /*#__PURE__*/ return((0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            lg: "3",
            md: "6",
            sm: "12",
            xs: "12",
            className: "d-flex align-self-center",
            style: giveAssuredPanelNew_outerBox,
            /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                    className: "d-flex align-self-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                            left: true,
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.src,
                                width: "50",
                                height: "50",
                                style: giveAssuredPanelNew_mediaImage,
                                alt: "money-raised"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                            body: true,
                            style: giveAssuredPanelNew_mediaMainBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                    heading: true,
                                    style: giveAssuredPanelNew_mediaMainHeading,
                                    children: item.totalNumber
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: item.desc
                                })
                            ]
                        })
                    ]
                })
            })
        }, indexg));
    });
    var giveassuredDetailsNew = giveAssuredPanelNew_items.map(function(item, indexg) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            lg: "6",
            md: "6",
            sm: "12",
            xs: "12",
            className: "d-flex align-self-center",
            style: giveAssuredPanelNew_outerBox,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                    className: "d-flex align-self-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* default */.Z, {
                        body: true,
                        style: giveAssuredPanelNew_mediaMainBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* default */.Z, {
                                heading: true,
                                style: mediaMainHeadings,
                                children: item.totalNumber
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: item.desc
                            })
                        ]
                    })
                })
            })
        }, indexg);
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
        className: "panel-padding",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-7611c525c938eb66" + " " + "hide-for-desktop",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-7611c525c938eb66" + " " + "giveassured-badge-image justify-content-center ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/give-assured-badge20.png"),
                                    alt: "give assured badge",
                                    style: {
                                        height: '24pt'
                                    },
                                    className: "jsx-7611c525c938eb66"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "jsx-7611c525c938eb66" + " " + "giveassured-details",
                                children: [
                                    "We ensure that ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        className: "jsx-7611c525c938eb66",
                                        children: "critical checks"
                                    }),
                                    " are done on all nonprofits and their projects to assure your donation does what it is supposed to - change lives."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-7611c525c938eb66" + " " + "giveassured-readmore ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/giveassured",
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    onClick: function() {
                                        if (window.eventDispatcher) {
                                            window.eventDispatcher.dispatchEventSync('giveassured-readmore', {}, {
                                                amplitude: true
                                            });
                                        }
                                    },
                                    className: "jsx-7611c525c938eb66" + " " + "",
                                    children: "Read more"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                        style: {
                            paddingBottom: '0rem',
                            paddingLeft: '3rem'
                        },
                        className: " hide-for-desktop",
                        children: giveassuredDetails
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "jsx-7611c525c938eb66" + " " + " hide-for-mobile giveassured-heading justify-content-center ",
                        children: "Giving you can trust"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                        className: "hide-for-mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-7611c525c938eb66" + " " + "giveassured-stats",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "6",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    style: {
                                        borderRight: '1px solid #dddddd'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: giveAssuredPanelNew_outerBox,
                                        className: "jsx-7611c525c938eb66",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(giveAssuredPanelNew_config.cdnUrl, "/static/images/home/give-assured-badge20.png"),
                                                alt: "give assured badge",
                                                style: {
                                                    height: '24pt'
                                                },
                                                className: "jsx-7611c525c938eb66"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    marginTop: '2rem'
                                                },
                                                className: "jsx-7611c525c938eb66",
                                                children: [
                                                    "We ensure that ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        className: "jsx-7611c525c938eb66",
                                                        children: "critical checks"
                                                    }),
                                                    " are done on all nonprofits and their projects to assure your donation does what it is supposed to - change lives. \xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/giveassured",
                                                        rel: "noopener noreferrer",
                                                        target: "_blank",
                                                        onClick: function() {
                                                            if (window.eventDispatcher) {
                                                                window.eventDispatcher.dispatchEventSync('giveassured-readmore', {}, {
                                                                    amplitude: true
                                                                });
                                                            }
                                                        },
                                                        className: "jsx-7611c525c938eb66" + " " + "",
                                                        children: "Read more"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                    lg: "6",
                                    md: "6",
                                    sm: "12",
                                    xs: "12",
                                    className: "p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                        children: giveassuredDetailsNew
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "7611c525c938eb66",
                children: ".giveassured-heading.jsx-7611c525c938eb66{text-align:center!important}\n.giveassured-badge-image.jsx-7611c525c938eb66{text-align:center!important}\n.giveassured-details.jsx-7611c525c938eb66{text-align:center!important;\nfont-size:22px;\npadding-top:1rem}\n.giveassured-readmore.jsx-7611c525c938eb66{text-align:center!important;\ncolor:var(--teal)}\n.giveassured-downpanel-iamge.jsx-7611c525c938eb66{width:35px;\nheight:70px}\n@media (max-width:768px) {.giveassured-text-panel.jsx-7611c525c938eb66{padding:1.5rem 0rem 1rem 0rem}\n.giveassured-details.jsx-7611c525c938eb66{font-size:20px}}\n@media (min-width:768px) {.giveassured-details.jsx-7611c525c938eb66{padding-left:4rem;\npadding-right:4rem}}"
            })
        ]
    }));
};
/* harmony default export */ var giveAssuredPanelNew = (GiveAssuredPanelNew);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/patners/index.js






function patners_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function patners_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function patners_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function patners_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) patners_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) patners_defineProperties(Constructor, staticProps);
    return Constructor;
}
function patners_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function patners_getPrototypeOf(o) {
    patners_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return patners_getPrototypeOf(o);
}
function patners_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) patners_setPrototypeOf(subClass, superClass);
}
function patners_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            patners_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function patners_possibleConstructorReturn(self, call) {
    if (call && (patners_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return patners_assertThisInitialized(self);
}
function patners_setPrototypeOf(o, p) {
    patners_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return patners_setPrototypeOf(o, p);
}
var patners_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function patners_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function patners_createSuper(Derived) {
    var hasNativeReflectConstruct = patners_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = patners_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = patners_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return patners_possibleConstructorReturn(this, result);
    };
}
var patners_config = (0,config["default"])().publicRuntimeConfig;
var settingsSliderDesktop = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true
};
var settingsSliderMobile = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true
};
var PatnersHomepage = /*#__PURE__*/ function(Component1) {
    "use strict";
    patners_inherits(PatnersHomepage, Component1);
    var _super = patners_createSuper(PatnersHomepage);
    function PatnersHomepage(props) {
        patners_classCallCheck(this, PatnersHomepage);
        var _this;
        _this = _super.call(this, props);
        patners_defineProperty(patners_assertThisInitialized(_this), "partnersTrack", function() {
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEvent('wedding-wishlist', eventInfo, {
                    amplitude: true
                });
            }
        });
        return _this;
    }
    patners_createClass(PatnersHomepage, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                var items = this.props.items;
                var imagePanel = items.map(function(item, pa) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        xs: "12",
                        sm: "12",
                        md: "2",
                        lg: "4",
                        onClick: function() {
                            return item.redirectUrl ? _this.partnersTrack : null;
                        },
                        className: " d-flex justify-content-center align-self-center",
                        children: item.redirectUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: item.redirectUrl,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "patner-image justify-content-center align-self-center",
                                src: "".concat(patners_config.cdnUrl).concat(item.imageUrl),
                                loading: "lazy",
                                alt: "stack images"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "patner-image justify-content-center align-self-center",
                            src: "".concat(patners_config.cdnUrl).concat(item.imageUrl),
                            loading: "lazy",
                            alt: "stack images"
                        })
                    }, pa);
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
                    fluid: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-b130b851427f91e0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "jsx-b130b851427f91e0" + " " + "text-center patner-heading",
                                    children: "Our Partners"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b130b851427f91e0" + " " + "hide-for-mobile partner-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, patners_objectSpread({}, settingsSliderDesktop, {
                                        children: imagePanel
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b130b851427f91e0" + " " + "hide-for-desktop partner-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, patners_objectSpread({}, settingsSliderMobile, {
                                        children: imagePanel
                                    }))
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "b130b851427f91e0",
                            children: ".patner-image{width:150px}\n.patner-heading{padding-bottom:1.5rem;\nfont-size:34px}\n.partner-list{margin-bottom:2rem}"
                        })
                    ]
                }));
            }
        }
    ]);
    return PatnersHomepage;
}(react.Component);


// EXTERNAL MODULE: ./components/chrome/elements/panels/missionsCard/index.js + 1 modules
var missionsCard = __webpack_require__(66172);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/testimonialPanelNew/index.js





function testimonialPanelNew_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function testimonialPanelNew_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function testimonialPanelNew_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function testimonialPanelNew_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) testimonialPanelNew_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) testimonialPanelNew_defineProperties(Constructor, staticProps);
    return Constructor;
}
function testimonialPanelNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonialPanelNew_getPrototypeOf(o) {
    testimonialPanelNew_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return testimonialPanelNew_getPrototypeOf(o);
}
function testimonialPanelNew_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) testimonialPanelNew_setPrototypeOf(subClass, superClass);
}
function testimonialPanelNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonialPanelNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function testimonialPanelNew_possibleConstructorReturn(self, call) {
    if (call && (testimonialPanelNew_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return testimonialPanelNew_assertThisInitialized(self);
}
function testimonialPanelNew_setPrototypeOf(o, p) {
    testimonialPanelNew_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return testimonialPanelNew_setPrototypeOf(o, p);
}
var testimonialPanelNew_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function testimonialPanelNew_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function testimonialPanelNew_createSuper(Derived) {
    var hasNativeReflectConstruct = testimonialPanelNew_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = testimonialPanelNew_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = testimonialPanelNew_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return testimonialPanelNew_possibleConstructorReturn(this, result);
    };
}
var testimonialPanelNew_config = (0,config["default"])().publicRuntimeConfig;
var TestimonialDesktopsettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true
};
var TestimonialMobilesettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000
};
var TestimonialPanelNew = /*#__PURE__*/ function(Component1) {
    "use strict";
    testimonialPanelNew_inherits(TestimonialPanelNew, Component1);
    var _super = testimonialPanelNew_createSuper(TestimonialPanelNew);
    function TestimonialPanelNew(props) {
        testimonialPanelNew_classCallCheck(this, TestimonialPanelNew);
        return _super.call(this, props);
    }
    testimonialPanelNew_createClass(TestimonialPanelNew, [
        {
            key: "render",
            value: function render() {
                var items = this.props.items;
                var testimonialdonorsdesktop = items.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: '1rem'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-home",
                            style: {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                        md: "6",
                                        sm: "12",
                                        xs: "12",
                                        lg: "5",
                                        className: "d-flex justify-content-center align-self-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            style: {
                                                width: '100%'
                                            },
                                            src: "".concat(testimonialPanelNew_config.cdnUrl).concat(item.urlimage),
                                            alt: item.altText,
                                            className: "testimonial-quotessss",
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                                        md: "6",
                                        sm: "12",
                                        xs: "12",
                                        lg: "7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "testimonial-heading",
                                                children: "What our beneficiaries say"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "testimonial-description",
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "testimonal-cta-desc",
                                                children: item.ctatext
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: item.ctalink,
                                                onClick: function() {
                                                    var eventInfo = {
                                                        name: item.cta
                                                    };
                                                    if (window.eventDispatcher) {
                                                        window.eventDispatcher.dispatchEventSync('testimonial-cta', eventInfo, {
                                                            amplitude: true
                                                        });
                                                    }
                                                },
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    style: {
                                                        width: 'auto'
                                                    },
                                                    color: "primary",
                                                    className: "btn-full-width btn btn-primary",
                                                    children: item.cta
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, index);
                });
                var testimonialDonorsMobile = items.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: '1rem'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            style: {
                                padding: '0rem .5rem 0rem .5rem'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        style: {
                                            width: '100%'
                                        },
                                        src: "".concat(testimonialPanelNew_config.cdnUrl).concat(item.urlimage),
                                        className: "testimonial-quotessss",
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "testimonial-description",
                                        children: item.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "testimonal-cta-desc",
                                        children: item.ctatext
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: item.ctalink,
                                        onClick: function() {
                                            var eventInfo = {
                                                name: item.cta
                                            };
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('testimonial-cta', eventInfo, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            style: {
                                                marginBottom: '1.5rem'
                                            },
                                            color: "primary",
                                            className: "btn-full-width btn btn-primary",
                                            children: item.cta
                                        })
                                    })
                                ]
                            })
                        })
                    }, index);
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
                    fluid: true,
                    style: {
                        padding: '0px',
                        marginTop: '1rem',
                        marginBottom: '2rem'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "testimonial-home-box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " hide-for-mobile testimonial-slider-dots testimonial-slick-arrow",
                                style: {
                                    padding: '1rem'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, testimonialPanelNew_objectSpread({}, TestimonialDesktopsettings, {
                                    className: "btn-slider",
                                    children: testimonialdonorsdesktop
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " hide-for-desktop testimonial-slider-dots testimonial-slider-dots-mobile testimonial-slick-arrow-moble",
                                style: {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "testimonial-heading",
                                        children: "What our beneficiaries say"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, testimonialPanelNew_objectSpread({}, TestimonialMobilesettings, {
                                        className: "btn-slider",
                                        children: testimonialDonorsMobile
                                    }))
                                ]
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return TestimonialPanelNew;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/reactstrap/es/Card.js
var Card = __webpack_require__(56941);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardTitle.js
var CardTitle = __webpack_require__(75351);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardText.js
var CardText = __webpack_require__(26094);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/missionsPanel/index.js





function missionsPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function missionsPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            missionsPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var missionsPanel_config = (0,config["default"])().publicRuntimeConfig;
var MissionsPanel = function(props) {
    var tenantConfig = props.tenantConfig, size = props.size, name = props.name, metaDescription = props.metaDescription, tagLine = props.tagLine, description = props.description, imgUrlPath = props.imgUrlPath, imgUrl = props.imgUrl, imgAlt = props.imgAlt, buttonText = props.buttonText, graphicText = props.graphicText, target = props.target, monthly_supporters = props.monthly_supporters, percentage_reached = props.percentage_reached, targetText = props.targetText, readmore = props.readmore;
    var number = percentage_reached;
    var percent = Math.round(number, -2);
    var graphictextmissions = graphicText.map(function(item, index) {
        /*#__PURE__*/ return((0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            xs: 6,
            md: 4,
            lg: 4,
            /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            width: '65%'
                        },
                        className: "missions-panel-right-icons",
                        src: item.thumbnail,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-center missions-panel-right-icons-heading ",
                        children: item.middletext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "",
                        children: item.text
                    })
                ]
            })
        }, index));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
        fluid: true,
        style: {
            padding: '0px'
        },
        className: "missions-panel-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: '1rem'
                    },
                    className: "jsx-fe31dd5e42106c17",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {},
                        className: "jsx-fe31dd5e42106c17" + " " + "missions-inner-panel missions-panel-mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            className: "missions-panel-outer-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, missionsPanel_objectSpread({}, size.left, {
                                    className: "missions-panel-mobile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-fe31dd5e42106c17" + " " + "justify-content-center align-self-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-fe31dd5e42106c17" + " " + "hide-for-desktop",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "jsx-fe31dd5e42106c17" + " " + "missions-panel-right-heading",
                                                        children: tagLine
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-fe31dd5e42106c17",
                                                        children: metaDescription
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                className: "missions-panel-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            src: "".concat(missionsPanel_config.cdnUrl).concat(imgUrlPath).concat(imgUrl),
                                                            alt: imgAlt,
                                                            className: "jsx-fe31dd5e42106c17" + " " + "gi-background-image"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-fe31dd5e42106c17" + " " + "card-inner-content",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle/* default */.Z, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            className: "jsx-fe31dd5e42106c17",
                                                                            children: name
                                                                        }),
                                                                        ' '
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardText/* default */.Z, {
                                                                    children: description
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-fe31dd5e42106c17" + " " + "progress-wrapper card-process-wrapper-content",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        paddingBottom: '10px'
                                                                    },
                                                                    className: "jsx-fe31dd5e42106c17" + " " + "",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "jsx-fe31dd5e42106c17" + " " + "supporting-card-bold-text",
                                                                        children: [
                                                                            target,
                                                                            " ",
                                                                            targetText
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                                                    className: "supporter-process-bar",
                                                                    value: percentage_reached
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        paddingTop: '10px',
                                                                        paddingBottom: '10px'
                                                                    },
                                                                    className: "jsx-fe31dd5e42106c17",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "jsx-fe31dd5e42106c17",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "jsx-fe31dd5e42106c17" + " " + "monthly-count-supporters",
                                                                                    children: monthly_supporters
                                                                                }),
                                                                                ' ',
                                                                                "supporters needed"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "jsx-fe31dd5e42106c17" + " " + "completed-supporters",
                                                                            children: [
                                                                                percent,
                                                                                "%",
                                                                                ' '
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, missionsPanel_objectSpread({}, size.right, {
                                    className: "right-side-panel-mobile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-fe31dd5e42106c17",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-fe31dd5e42106c17" + " " + "hide-for-mobile",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "jsx-fe31dd5e42106c17" + " " + "missions-panel-right-heading",
                                                        children: tagLine
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-fe31dd5e42106c17",
                                                        children: metaDescription
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    paddingTop: '2rem',
                                                    paddingBottom: '2rem'
                                                },
                                                className: "jsx-fe31dd5e42106c17" + " " + "hide-for-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                                    children: graphictextmissions
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                    xs: "12",
                                                    sm: "12",
                                                    md: "6",
                                                    lg: "6",
                                                    className: "campaign-btn-mobile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/missions/".concat(readmore),
                                                        onClick: function() {
                                                            if (window.eventDispatcher) {
                                                                window.eventDispatcher.dispatchEventSync('missions-btn', {}, {
                                                                    amplitude: true
                                                                });
                                                            }
                                                        },
                                                        className: "jsx-fe31dd5e42106c17",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            color: tenantConfig.theme.primaryCTA.backgroundColor,
                                                            className: "btn btn-primary ",
                                                            children: [
                                                                ' ',
                                                                buttonText
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }))
                            ]
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "fe31dd5e42106c17",
                children: ".image-card-top{border-style:none}\n.card-inner-content{padding-top:1rem;\npadding-right:1rem;\npadding-left:1rem}\n.card-process-wrapper-content{padding-top:1rem;\npadding-right:1rem;\npadding-bottom:1rem;\npadding-left:1rem}\n.card-price{margin-bottom:10px}\n.card-price h6{margin-bottom:0;\nfont-weight:600}\n.tag-row{margin-bottom:10px}\n.giveassured-position{position:absolute;\nbottom:3px;\nright:3px;\nbackground:white;\npadding:1px 5px;\nborder-radius:5px;\nbox-shadow:0 2px 2px rgba(50, 50, 93, 0), 0 1px 2px rgba(0, 0, 0, 0.08)}\n.supporting-card-bold-text{font-weight:600;\nfont-size:18px;\ncolor:#444444}\n.supporter-process-bar.progress{height:8px!important}\n.supporter-process-bar .progress-bar{background:#ff5050!important}\n.completed-supporters{float:right;\ncolor:#666666!important}\n.monthly-count-supporters{color:#666666!important}\n.missions-panel-box{background-image:url('https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/mission-banner/missions-bg-desktop.jpg');\nheight:100%}\n.missions-card .card{width:22rem}\n.missions-panel-btn{height:50px!important;\nfont-size:1.25rem}\n@media (max-width:576px) {.missions-panel-mobile{padding:0px}\n.campaign-btn-mobile{padding:0px!important}\n.right-side-panel-mobile{padding-right:0px;\npadding-left:05px}}\n.missions-panel-right-icons{display:block;\nmargin-left:auto;\nmargin-right:auto}\n.missions-panel-right-icons-heading{font-size:34px}\n.missions-panel-right-readmore{display:inline;\npadding-left:2rem}\n.missions-panel-outer-box{padding-top:2rem;\npadding-bottom:2rem}\n@media (max-width:768px) {.missions-panel-right-readmore{text-align:center!important;\ndisplay:block;\npadding-top:1rem}\n.missions-panel-outer-box{padding-top:1rem;\npadding-bottom:0rem}}"
            })
        ]
    }));
};
MissionsPanel.defaultProps = {
    className: 'gi-campaign-panel d-flex',
    title: 'mission 10 million meals',
    description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
    needed: 1270,
    completed: 80,
    size: {
        left: {
            xs: 12,
            sm: 12,
            md: '8',
            lg: '5',
            xl: '5'
        },
        right: {
            xs: 12,
            sm: 12,
            md: '8',
            lg: '7',
            xl: '7'
        }
    },
    tags: [
        {
            type: 'extremeneed',
            design: 'capsule'
        }, 
    ],
    image: '/static/images/campaign/target-image1.jpg',
    partnerImage: '/static/images/campaign/mission-partner-ngo.png',
    link: '#'
};
/* harmony default export */ var missionsPanel = (MissionsPanel);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/joinMissionPanel/index.js



var joinMissionPanel_config = (0,config["default"])().publicRuntimeConfig;
var JoinMissionPanel = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            marginTop: '2rem'
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center hide-for-mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "",
                    style: {
                        width: '65%'
                    },
                    loading: "lazy",
                    src: "".concat(joinMissionPanel_config.cdnUrl, "/static/images/home/homev2/brush-desktop-group-image.jpg"),
                    alt: "Desktop"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center hide-for-desktop ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "",
                    style: {
                        width: '90%'
                    },
                    loading: "lazy",
                    src: "".concat(joinMissionPanel_config.cdnUrl, "/static/images/home/homev2/join-our-mission-mobile.jpg"),
                    alt: "Mobile"
                })
            })
        ]
    }));
};
/* harmony default export */ var joinMissionPanel = (JoinMissionPanel);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/CampaignPanelNew/index.js





function CampaignPanelNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CampaignPanelNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CampaignPanelNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CampaignPanelNew_config = (0,config["default"])().publicRuntimeConfig;
var CampaignPanelNew_items = [
    {
        thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/Homepage%2Bicons_A.png",
        middletext: '1 in 3',
        text: 'More than a third of the world’s malnourished children live in India'
    },
    {
        thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/Homepage%2Bicons_B.png",
        middletext: '2 in 3',
        text: 'More than 2/3rds deaths of under-fives attributed to malnutrition'
    },
    {
        thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/impactmidday+mea.png",
        middletext: '95.1M',
        text: '95.1M children deprived of midday meals at school during COVID-19'
    }, 
];
var CampaignPanelNew = function(props) {
    var className = props.className, title = props.title, description = props.description, needed = props.needed, completed = props.completed, size = props.size, image1 = props.image1, tags = props.tags, partnerImage = props.partnerImage, link = props.link, tenantConfig = props.tenantConfig, theme = props.theme;
    var linkStartUtm = link && link.indexOf('?utm_source') - 1;
    var linkWithoutUtm = linkStartUtm > -1 ? link.substring(0, linkStartUtm) : link;
    var graphictextmissions = CampaignPanelNew_items.map(function(item, gmt) {
        /*#__PURE__*/ return((0,jsx_runtime.jsx)(es_Col/* default */.Z, {
            xs: 6,
            md: 4,
            lg: 4,
            className: "",
            /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            width: '55%'
                        },
                        className: "missions-panel-right-icons",
                        loading: "lazy",
                        src: item.thumbnail,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-center missions-panel-right-icons-heading ",
                        children: item.middletext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "",
                        children: item.text
                    })
                ]
            })
        }, gmt));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Container/* default */.Z, {
        fluid: true,
        style: {
            padding: '0px'
        },
        className: "missions-panel-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: '1rem'
                    },
                    className: "jsx-eb052f4e726e9fa7" + " " + (className || ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {},
                        className: "jsx-eb052f4e726e9fa7" + " " + "missions-inner-panel missions-panel-mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                            className: "missions-panel-outer-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, CampaignPanelNew_objectSpread({}, size.left, {
                                    className: "missions-panel-mobile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-eb052f4e726e9fa7" + " " + "justify-content-center align-self-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-eb052f4e726e9fa7" + " " + "hide-for-desktop",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "jsx-eb052f4e726e9fa7" + " " + "missions-panel-right-heading",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-eb052f4e726e9fa7",
                                                        children: description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                className: "missions-panel-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: linkWithoutUtm,
                                                    onClick: function() {
                                                        if (window.eventDispatcher) {
                                                            window.eventDispatcher.dispatchEventSync('homepage-campagin-card', {}, {
                                                                amplitude: true
                                                            });
                                                        }
                                                    },
                                                    style: {
                                                        textDecoration: 'none'
                                                    },
                                                    className: "jsx-eb052f4e726e9fa7",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                style: {
                                                                    width: '100%'
                                                                },
                                                                src: "".concat(CampaignPanelNew_config.cdnUrl).concat(image1),
                                                                alt: title,
                                                                loading: "lazy",
                                                                className: "jsx-eb052f4e726e9fa7" + " " + "gi-background-image"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-eb052f4e726e9fa7" + " " + "card-inner-content",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle/* default */.Z, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "jsx-eb052f4e726e9fa7",
                                                                                children: "Rise Against Hunger"
                                                                            }),
                                                                            ' '
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardText/* default */.Z, {
                                                                        style: {
                                                                            color: '#444444'
                                                                        },
                                                                        children: "Mission: 10 Million Meals is an endeavor to deliver 10 million mid-day meals to schoolchildren in one year. All it takes is 2,000 donors committing to donate ₹2,000 ($30) every month and 43,000 hungry children can be fed one hot meal every school day in 19 states across India."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-eb052f4e726e9fa7" + " " + "progress-wrapper card-process-wrapper-content",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                                                        className: "supporter-process-bar",
                                                                        value: completed
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            paddingTop: '10px',
                                                                            paddingBottom: '10px'
                                                                        },
                                                                        className: "jsx-eb052f4e726e9fa7",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                style: {
                                                                                    color: '#444444'
                                                                                },
                                                                                className: "jsx-eb052f4e726e9fa7",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "jsx-eb052f4e726e9fa7" + " " + "monthly-count-supporters",
                                                                                        children: needed
                                                                                    }),
                                                                                    ' ',
                                                                                    "supporters needed"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "jsx-eb052f4e726e9fa7" + " " + "completed-supporters",
                                                                                children: [
                                                                                    completed,
                                                                                    "%",
                                                                                    ' '
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, CampaignPanelNew_objectSpread({}, size.right, {
                                    className: "right-side-panel-mobile",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-eb052f4e726e9fa7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-eb052f4e726e9fa7" + " " + "hide-for-mobile",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "jsx-eb052f4e726e9fa7" + " " + "missions-panel-right-heading",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "jsx-eb052f4e726e9fa7",
                                                        children: "One in three of the world’s malnourished children live in India. Our children are going to school hungry. They suffer from lack of concentration and reduced cognitive development, directly leading to their dropping out of school. Join us in our mission to prevent hunger diminishing our children’s opportunities to succeed."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    paddingTop: '1rem',
                                                    paddingBottom: '1rem'
                                                },
                                                className: "jsx-eb052f4e726e9fa7" + " " + "hide-for-mobile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                                    children: graphictextmissions
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                                    xs: "12",
                                                    sm: "12",
                                                    md: "12",
                                                    lg: "6",
                                                    className: "campaign-btn-mobile p-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: linkWithoutUtm,
                                                        onClick: function() {
                                                            if (window.eventDispatcher) {
                                                                window.eventDispatcher.dispatchEventSync('homepage-campagin-btn', {}, {
                                                                    amplitude: true
                                                                });
                                                            }
                                                        },
                                                        className: "jsx-eb052f4e726e9fa7",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            color: "primary",
                                                            className: "btn-full-width campaign-panel-givenow",
                                                            children: "Feed a hungry child"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }))
                            ]
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "eb052f4e726e9fa7",
                children: ".image-card-top{border-style:none}\n.card-inner-content{padding-top:1rem;\npadding-right:1rem;\npadding-left:1rem}\n.card-process-wrapper-content{padding-top:1rem;\npadding-right:1rem;\npadding-bottom:1rem;\npadding-left:1rem}\n.card-price{margin-bottom:10px}\n.card-price h6{margin-bottom:0;\nfont-weight:600}\n.tag-row{margin-bottom:10px}\n.giveassured-position{position:absolute;\nbottom:3px;\nright:3px;\nbackground:white;\npadding:1px 5px;\nborder-radius:5px;\nbox-shadow:0 2px 2px rgba(50, 50, 93, 0), 0 1px 2px rgba(0, 0, 0, 0.08)}\n.supporting-card-bold-text{font-weight:600;\nfont-size:18px;\ncolor:#444444}\n.supporter-process-bar.progress{height:8px!important}\n.supporter-process-bar .progress-bar{background:#ff5050!important}\n.completed-supporters{float:right;\ncolor:#666666!important}\n.monthly-count-supporters{color:#666666!important}\n.missions-panel-box{background-image:url('https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/mission-banner/missions-bg-desktop.jpg');\nheight:100%}\n.missions-card .card{width:22rem}\n.missions-panel-btn{height:50px!important;\nfont-size:1.25rem}\n@media (max-width:992px) {.missions-panel-mobile{padding:0px}\n.campaign-btn-mobile{padding:0px!important}\n.right-side-panel-mobile{padding-right:0px;\npadding-left:05px}\n.card{margin-bottom:2rem!important}}\n.missions-panel-right-icons{display:block;\nmargin-left:auto;\nmargin-right:auto}\n.missions-panel-right-icons-heading{font-size:34px}\n.missions-panel-right-readmore{display:inline;\npadding-left:2rem}\n.missions-panel-outer-box{padding-top:2rem;\npadding-bottom:2rem}\n@media (max-width:768px) {.missions-panel-right-readmore{text-align:center!important;\ndisplay:block;\npadding-top:1rem}\n.missions-panel-outer-box{padding-top:1rem;\npadding-bottom:0rem;\nmargin-bottom:2rem}}"
            })
        ]
    }));
};
CampaignPanelNew.defaultProps = {
    className: ' d-flex',
    title: 'mission 10 million meals',
    description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
    needed: 1270,
    completed: 80,
    size: {
        left: {
            xs: 12,
            sm: 12,
            md: '12',
            lg: '5',
            xl: '5'
        },
        right: {
            xs: 12,
            sm: 12,
            md: '12',
            lg: '7',
            xl: '7'
        }
    },
    tags: [
        {
            type: 'extremeneed',
            design: 'capsule'
        }, 
    ],
    image: '/static/images/campaign/target-image1.jpg',
    partnerImage: '/static/images/campaign/mission-partner-ngo.png',
    link: '#'
};
/* harmony default export */ var panels_CampaignPanelNew = (CampaignPanelNew);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/missionPanelNew/rightSideTiles.js




var rightSideTiles_config = (0,config["default"])().publicRuntimeConfig;
var MissionsCardRight = function(props) {
    var _mission = props.mission, slug = _mission.slug, image = _mission.image, buttonText = _mission.buttonText, stats = _mission.stats, name = _mission.name;
    var number = stats.percentage_reached;
    var completed_percentage = Math.floor(number, -2);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
        style: {
            borderBottom: "1px solid #dddddd",
            marginBottom: "0.5rem",
            paddingBottom: "0.5rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                lg: "5",
                md: "6",
                sm: "6",
                xs: "6",
                style: {},
                className: "p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "/missions/".concat(slug),
                    onClick: function() {
                        if (window.eventDispatcher) {
                            window.eventDispatcher.dispatchEventSync("missions-card-btn-desktop-image", {}, {
                                amplitude: true
                            });
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(rightSideTiles_config.cdnUrl).concat(image.imgUrlPath).concat(image.imgUrl),
                        alt: image.imgAlt,
                        style: {
                            height: "7rem"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Col/* default */.Z, {
                lg: "7",
                md: "6",
                sm: "6",
                xs: "6",
                className: "p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            name,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        style: {
                            paddingTop: "4px",
                            color: "#008c8c"
                        },
                        children: [
                            completed_percentage,
                            "% funded"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/missions/".concat(slug),
                        onClick: function() {
                            if (window.eventDispatcher) {
                                window.eventDispatcher.dispatchEventSync("missions-card-btn-desktop-left", {}, {
                                    amplitude: true
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            color: "primary",
                            className: "btn-full-width btn btn-primary",
                            style: {
                                marginTop: "12px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "give-now-button-icon",
                                    src: "".concat(rightSideTiles_config.cdnUrl, "/static/icons/heart-donation-programs-page.svg"),
                                    alt: "Hearts"
                                }),
                                buttonText
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var rightSideTiles = (MissionsCardRight);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/missionPanelNew/index.js





function missionPanelNew_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function missionPanelNew_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function missionPanelNew_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function missionPanelNew_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) missionPanelNew_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) missionPanelNew_defineProperties(Constructor, staticProps);
    return Constructor;
}
function missionPanelNew_getPrototypeOf(o) {
    missionPanelNew_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return missionPanelNew_getPrototypeOf(o);
}
function missionPanelNew_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) missionPanelNew_setPrototypeOf(subClass, superClass);
}
function missionPanelNew_possibleConstructorReturn(self, call) {
    if (call && (missionPanelNew_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return missionPanelNew_assertThisInitialized(self);
}
function missionPanelNew_setPrototypeOf(o, p) {
    missionPanelNew_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return missionPanelNew_setPrototypeOf(o, p);
}
var missionPanelNew_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function missionPanelNew_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function missionPanelNew_createSuper(Derived) {
    var hasNativeReflectConstruct = missionPanelNew_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = missionPanelNew_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = missionPanelNew_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return missionPanelNew_possibleConstructorReturn(this, result);
    };
}
var missionPanelNew_config = (0,config["default"])().publicRuntimeConfig;
var MissionsCard = // function shuffleMissions(missions) {
//   let i = missions.length - 1;
//   for (; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     const temp = missions[i];
//     missions[i] = missions[j];
//     missions[j] = temp;
//   }
//   return missions;
// }
/*#__PURE__*/ function(_Component) {
    "use strict";
    missionPanelNew_inherits(MissionsCard, _Component);
    var _super = missionPanelNew_createSuper(MissionsCard);
    function MissionsCard(props) {
        missionPanelNew_classCallCheck(this, MissionsCard);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            missionsData: []
        };
        return _this;
    }
    missionPanelNew_createClass(MissionsCard, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, missions = _props.missions, title = _props.title;
                // const missionss = shuffleMissions(missions);
                // const missionRandom = Math.floor(Math.random() * 5) + 1;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(es_Container/* default */.Z, {
                    className: "hide-for-mobile",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_Row/* default */.Z, {
                        style: {},
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                lg: "6",
                                md: "6",
                                sm: "12",
                                xs: "12",
                                className: "p-0",
                                style: {
                                    borderRight: "1px solid #dddddd"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        padding: "2rem 3rem 3rem 2rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            style: {
                                                fontSize: "1rem"
                                            },
                                            children: "FEATURED MISSIONS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(missionPanelNew_config.cdnUrl).concat(missions[0].image.imgUrlPath).concat(missions[0].image.imgUrl),
                                            alt: missions[0].image.imgAlt,
                                            style: {
                                                width: "100%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                paddingTop: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: missions[0].name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: missions[0].description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                            className: "supporter-process-bar",
                                            value: missions[0].stats.percentage_reached
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/missions/".concat(missions[0].slug),
                                            onClick: function() {
                                                if (window.eventDispatcher) {
                                                    window.eventDispatcher.dispatchEventSync("missions-card-btn-dektop-left", {}, {
                                                        amplitude: true
                                                    });
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                color: "primary",
                                                className: "btn-full-width btn btn-primary",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "give-now-button-icon",
                                                        src: "".concat(missionPanelNew_config.cdnUrl, "/static/icons/heart-donation-programs-page.svg"),
                                                        alt: "Hearts"
                                                    }),
                                                    missions[0].buttonText
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, {
                                lg: "6",
                                md: "6",
                                sm: "12",
                                xs: "12",
                                className: "p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        padding: "2rem 2rem 3rem 3rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            style: {
                                                fontSize: "1rem"
                                            },
                                            children: "OTHER MISSIONS YOU CAN SUPPORT"
                                        }),
                                        missions.slice(1, missions.length + 1).map(function(mission, indexm) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(rightSideTiles, {
                                                mission: mission
                                            }, indexm);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return MissionsCard;
}(react.Component);
/* harmony default export */ var missionPanelNew = (MissionsCard);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/mediaPanel/index.js



// import './media.scss';


function mediaPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function mediaPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function mediaPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function mediaPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) mediaPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) mediaPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function mediaPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mediaPanel_getPrototypeOf(o) {
    mediaPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return mediaPanel_getPrototypeOf(o);
}
function mediaPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) mediaPanel_setPrototypeOf(subClass, superClass);
}
function mediaPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mediaPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mediaPanel_possibleConstructorReturn(self, call) {
    if (call && (mediaPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return mediaPanel_assertThisInitialized(self);
}
function mediaPanel_setPrototypeOf(o, p) {
    mediaPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return mediaPanel_setPrototypeOf(o, p);
}
var mediaPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function mediaPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function mediaPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = mediaPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = mediaPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = mediaPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return mediaPanel_possibleConstructorReturn(this, result);
    };
}
var mediaPanel_config = (0,config["default"])().publicRuntimeConfig;
var MediaDesktopsettings = {
    dots: true,
    // infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 5000,
    arrows: false,
    appendDots: function(dots) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    " ",
                    dots,
                    " "
                ]
            })
        });
    },
    customPaging: function(i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "dot-item"
        });
    }
};
var MediaMobilesettings = {
    dots: true,
    // infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 5000,
    arrows: false,
    appendDots: function(dots) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    " ",
                    dots,
                    " "
                ]
            })
        });
    },
    customPaging: function(i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "dot-item"
        });
    }
};
var index = /*#__PURE__*/ function(Component1) {
    "use strict";
    mediaPanel_inherits(index, Component1);
    var _super = mediaPanel_createSuper(index);
    function index() {
        mediaPanel_classCallCheck(this, index);
        var _this;
        _this = _super.apply(this, arguments);
        mediaPanel_defineProperty(mediaPanel_assertThisInitialized(_this), "mediaPanelCard", function(items) {
            return items.map(function(item, idx) {
                var _obj;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(es_Col/* default */.Z, (_obj = {
                    className: ""
                }, mediaPanel_defineProperty(_obj, "className", "media-card-for-mobile"), mediaPanel_defineProperty(_obj, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.blogUrl,
                    rel: "nofollow",
                    onClick: function() {
                        var eventInfo = {
                            name: item.heading
                        };
                        if (window.eventDispatcher) {
                            window.eventDispatcher.dispatchEventSync('media-panel-card', eventInfo, {
                                amplitude: true
                            });
                        }
                    },
                    style: {
                        textDecoration: 'none'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        className: "missions-card in-news-panel",
                        style: {
                            boxShadow: '0 0 7px 0 rgb(0 0 0 / 25%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: 'relative'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: '100%'
                                    },
                                    src: "".concat(mediaPanel_config.cdnUrl).concat(item.src),
                                    alt: item.heading
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "missions-card-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "media-card-homepage",
                                                style: {
                                                    color: '#444',
                                                    marginBottom: '3px'
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: item.heading
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "media-card-date",
                                                children: item.date
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "logo-block",
                                        style: {
                                            borderTop: '1px solid #f2f2f2'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "img-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(mediaPanel_config.cdnUrl).concat(item.imgSrc),
                                                    alt: "logo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: '#444'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        children: "by"
                                                    }),
                                                    " ",
                                                    item.creatorName
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })), _obj), idx));
            });
        });
        return _this;
    }
    mediaPanel_createClass(index, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "homescreen-media-blog",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "In the News"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hs-blog-border-bottom"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hide-for-mobile",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, mediaPanel_objectSpread({}, MediaDesktopsettings, {
                                    children: this.mediaPanelCard(this.props.items)
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hide-for-desktop",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, mediaPanel_objectSpread({}, MediaMobilesettings, {
                                    children: this.mediaPanelCard(this.props.items)
                                }))
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return index;
}(react.Component);


// EXTERNAL MODULE: ./components/chrome/elements/icons/fontAwesomeSVGIcon.js
var fontAwesomeSVGIcon = __webpack_require__(44106);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/donorTestimonials/index.js




// import './donorTestimonials.scss';


function donorTestimonials_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function donorTestimonials_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function donorTestimonials_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function donorTestimonials_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) donorTestimonials_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) donorTestimonials_defineProperties(Constructor, staticProps);
    return Constructor;
}
function donorTestimonials_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function donorTestimonials_getPrototypeOf(o) {
    donorTestimonials_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return donorTestimonials_getPrototypeOf(o);
}
function donorTestimonials_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) donorTestimonials_setPrototypeOf(subClass, superClass);
}
function donorTestimonials_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            donorTestimonials_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function donorTestimonials_possibleConstructorReturn(self, call) {
    if (call && (donorTestimonials_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return donorTestimonials_assertThisInitialized(self);
}
function donorTestimonials_setPrototypeOf(o, p) {
    donorTestimonials_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return donorTestimonials_setPrototypeOf(o, p);
}
var donorTestimonials_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function donorTestimonials_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function donorTestimonials_createSuper(Derived) {
    var hasNativeReflectConstruct = donorTestimonials_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = donorTestimonials_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = donorTestimonials_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return donorTestimonials_possibleConstructorReturn(this, result);
    };
}
var donorTestimonials_config = (0,config["default"])().publicRuntimeConfig;
var DonorTestimonialsettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(DtNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(DtPrevArrow, {}),
    appendDots: function(dots) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    " ",
                    dots,
                    " "
                ]
            })
        });
    },
    customPaging: function(i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "dot-item"
        });
    }
};
function DtPrevArrow(props) {
    var onClick = props.onClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dtm-arrow arrow-prev",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "dtm-arrow-svg",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0 L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109 c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483 c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788 S18.707,9.212,18.271,9.212z"
            })
        })
    }));
}
function DtNextArrow(props) {
    var onClick = props.onClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dtm-arrow arrow-next",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "dtm-arrow-svg",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0 l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109 c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483 c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788 S1.293,9.212,1.729,9.212z"
            })
        })
    }));
}
var index1 = /*#__PURE__*/ function(Component1) {
    "use strict";
    donorTestimonials_inherits(index1, Component1);
    var _super = donorTestimonials_createSuper(index1);
    function index1(props) {
        donorTestimonials_classCallCheck(this, index1);
        return _super.call(this, props);
    }
    donorTestimonials_createClass(index1, [
        {
            key: "render",
            value: function render() {
                var donortestimonial = this.props.items.map(function(item, index2) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dtm-items",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dtm-items-img",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(donorTestimonials_config.cdnUrl).concat(item.imageUrl),
                                        alt: item.imageAlt
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dtm-items-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "dtm-beneficiary",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dtm-beneficiary-bio",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: item.profileName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: item.profileDescription
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "“ ",
                                                item.description,
                                                " ”"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index2);
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "donor-testimonials-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "donor-testimonials container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dtm-header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Testimonials"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "dtm-header-bar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dtm-items-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, donorTestimonials_objectSpread({}, DonorTestimonialsettings, {
                                    children: donortestimonial
                                }))
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return index1;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/elements/panels/corporatePartners/index.js


// import './corporatePartners.scss';

function corporatePartners_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function corporatePartners_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function corporatePartners_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function corporatePartners_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) corporatePartners_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) corporatePartners_defineProperties(Constructor, staticProps);
    return Constructor;
}
function corporatePartners_getPrototypeOf(o) {
    corporatePartners_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return corporatePartners_getPrototypeOf(o);
}
function corporatePartners_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) corporatePartners_setPrototypeOf(subClass, superClass);
}
function corporatePartners_possibleConstructorReturn(self, call) {
    if (call && (corporatePartners_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return corporatePartners_assertThisInitialized(self);
}
function corporatePartners_setPrototypeOf(o, p) {
    corporatePartners_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return corporatePartners_setPrototypeOf(o, p);
}
var corporatePartners_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function corporatePartners_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function corporatePartners_createSuper(Derived) {
    var hasNativeReflectConstruct = corporatePartners_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = corporatePartners_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = corporatePartners_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return corporatePartners_possibleConstructorReturn(this, result);
    };
}
var corporatePartners_config = (0,config["default"])().publicRuntimeConfig;
var CorporatePartners = /*#__PURE__*/ function(Component1) {
    "use strict";
    corporatePartners_inherits(CorporatePartners, Component1);
    var _super = corporatePartners_createSuper(CorporatePartners);
    function CorporatePartners() {
        corporatePartners_classCallCheck(this, CorporatePartners);
        return _super.apply(this, arguments);
    }
    corporatePartners_createClass(CorporatePartners, [
        {
            key: "render",
            value: function render() {
                var img = this.props.img;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "partners-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "partners-wrapper container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "partners-out",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "partners-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Partners"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "partners-hr"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Trusted by the largest brands and corporations, and the most impactful foundations around the world"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "partners-logos",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "partners-list-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(corporatePartners_config.cdnUrl).concat(img),
                                        alt: "nonprofit",
                                        loading: "lazy"
                                    })
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return CorporatePartners;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/newsletterPanelNew/index.js





function newsletterPanelNew_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function newsletterPanelNew_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function newsletterPanelNew_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function newsletterPanelNew_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) newsletterPanelNew_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) newsletterPanelNew_defineProperties(Constructor, staticProps);
    return Constructor;
}
function newsletterPanelNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function newsletterPanelNew_getPrototypeOf(o) {
    newsletterPanelNew_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return newsletterPanelNew_getPrototypeOf(o);
}
function newsletterPanelNew_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) newsletterPanelNew_setPrototypeOf(subClass, superClass);
}
function newsletterPanelNew_possibleConstructorReturn(self, call) {
    if (call && (newsletterPanelNew_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return newsletterPanelNew_assertThisInitialized(self);
}
function newsletterPanelNew_setPrototypeOf(o, p) {
    newsletterPanelNew_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return newsletterPanelNew_setPrototypeOf(o, p);
}
var newsletterPanelNew_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function newsletterPanelNew_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function newsletterPanelNew_createSuper(Derived) {
    var hasNativeReflectConstruct = newsletterPanelNew_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = newsletterPanelNew_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = newsletterPanelNew_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return newsletterPanelNew_possibleConstructorReturn(this, result);
    };
}
// import './newsletterPanelNew.scss';
var newsletterPanelNew_config = (0,config["default"])().publicRuntimeConfig;
var newsletterfeatureIcon1 = "".concat(newsletterPanelNew_config.cdnUrl, "/static/images/newsletter/stories.svg");
var newsletterfeatureIcon2 = "".concat(newsletterPanelNew_config.cdnUrl, "/static/images/newsletter/fact-fiction.svg");
var newsletterfeatureIcon3 = "".concat(newsletterPanelNew_config.cdnUrl, "/static/images/newsletter/impact.svg");
var NewsletterPanelNew = /*#__PURE__*/ function(_Component) {
    "use strict";
    newsletterPanelNew_inherits(NewsletterPanelNew, _Component);
    var _super = newsletterPanelNew_createSuper(NewsletterPanelNew);
    function NewsletterPanelNew(props) {
        newsletterPanelNew_classCallCheck(this, NewsletterPanelNew);
        var _this;
        _this = _super.call(this, props);
        newsletterPanelNew_defineProperty(newsletterPanelNew_assertThisInitialized(_this), "submitNewsletterSubscriptionForm", function(event) {
            event.preventDefault();
            var name = "";
            var email = document.getElementById('ns-sub-panel-email').value;
            axios_default()({
                method: 'post',
                url: "/api/v1.1/leadGen/create",
                data: {
                    email: email,
                    name: name,
                    source: 'newsletters-homepage',
                    _csrf: _this.props._csrf
                }
            }).then(function(res) {
                if (res.data.status) {
                    var eventData = {
                        content_name: 'newsletter-registration-homepage',
                        status: true
                    };
                    if (window.eventDispatcher) {
                        window.eventDispatcher.dispatchEvent('Lead', eventData, {
                            fbPixel: true
                        });
                    }
                    _this.setState({
                        messageSubmitted: true,
                        message: 'Thank you for signing up!'
                    });
                } else {
                    _this.setState({
                        messageSubmitted: true,
                        message: 'You have already signed up for our newsletter'
                    });
                }
            }).catch(function(err) {});
        });
        _this.state = {
            messageSubmitted: false
        };
        return _this;
    }
    newsletterPanelNew_createClass(NewsletterPanelNew, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "newsletter-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "newsletter-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "newsletter-emailpanel",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Add Meaning To Your Inbox"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "newsletter-bar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "newsletter-panel",
                                children: [
                                    !this.state.messageSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Sign up today - Stay Informed, be Involved"
                                    }) : '',
                                    !this.state.messageSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        onSubmit: function(e) {
                                            return _this.submitNewsletterSubscriptionForm(e);
                                        },
                                        className: "newsletter-form",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "input-group",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    style: {
                                                        width: '70%',
                                                        borderRadius: '0',
                                                        border: '1px solid #ff5050'
                                                    },
                                                    required: true,
                                                    type: "email",
                                                    name: "Email",
                                                    id: "ns-sub-panel-email",
                                                    placeholder: "Enter Email Address",
                                                    className: "form-control newsletter-input"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "input-group-btn",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn btn-default",
                                                        style: {
                                                            borderRadius: "0",
                                                            backgroundColor: '#ff5050',
                                                            color: "#fff"
                                                        },
                                                        children: "SIGN UP"
                                                    })
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "justify-content-center",
                                        style: {
                                            alignItems: 'center',
                                            maxWidth: '100%'
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                paddingTop: '1rem',
                                                fontSize: '20px'
                                            },
                                            children: this.state.message
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return NewsletterPanelNew;
}(react.Component);
/* harmony default export */ var newsletterPanelNew = ((0,react_contextual_es/* subscribe */.Ld)()(NewsletterPanelNew));

;// CONCATENATED MODULE: ./components/chrome/elements/panels/icrfPanel/index.js


function icrfPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function icrfPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function icrfPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function icrfPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) icrfPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) icrfPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function icrfPanel_getPrototypeOf(o) {
    icrfPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return icrfPanel_getPrototypeOf(o);
}
function icrfPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) icrfPanel_setPrototypeOf(subClass, superClass);
}
function icrfPanel_possibleConstructorReturn(self, call) {
    if (call && (icrfPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return icrfPanel_assertThisInitialized(self);
}
function icrfPanel_setPrototypeOf(o, p) {
    icrfPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return icrfPanel_setPrototypeOf(o, p);
}
var icrfPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function icrfPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function icrfPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = icrfPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = icrfPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = icrfPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return icrfPanel_possibleConstructorReturn(this, result);
    };
}
var icrfPanel_index = /*#__PURE__*/ function(Component1) {
    "use strict";
    icrfPanel_inherits(index, Component1);
    var _super = icrfPanel_createSuper(index);
    function index() {
        icrfPanel_classCallCheck(this, index);
        return _super.apply(this, arguments);
    }
    icrfPanel_createClass(index, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "icrf-panel-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icrf-verticle-titile",
                            children: "ICRF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "icrf-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "icrf-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "icrf-header",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "India COVID Response Fund"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "icrf-header-bar"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "icrf-left-content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "We launched ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://cfstatic.giveindia.org/a1a4829a-2a74-4b0a-96b7-7c5d9b46a24f.pdf",
                                                        target: "_blank",
                                                        style: {
                                                            color: '#008c8c'
                                                        },
                                                        children: "India COVID Response Fund-1"
                                                    }),
                                                    " in April 2020 raising ₹220Cr+ from individuals, foundations & corporations. With the 2nd deadly wave a year later, we started ICRF-2 to support gaps in healthcare & provide humanitarian aid."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "icrf-banner",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://covid.giveindia.org/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "icrf-banner-desk",
                                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-desktop.jpg",
                                                        alt: "banner-desktop"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://covid.giveindia.org/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "icrf-banner-mob",
                                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-mob.jpg",
                                                        alt: "banner-mobile"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icrf-right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "icrf-stats",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "icrf-stats-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-raised-icon.png",
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "₹ 670Cr+"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Funds raised for humanitarian aid and to augment healthcare infrastructure"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "icrf-stats-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-supporters-icon.png",
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "50000"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Indians supported across 22 states with funds for our COVID relief work"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "icrf-stats-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/icrf-ngo-icon.png",
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "300+"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "NGOs and implementation partners working on ground to create widespread impact"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return index;
}(react.Component);
// import './icrfPanel.scss';


;// CONCATENATED MODULE: ./components/chrome/elements/panels/whyGiveIndiaPanel/index.js



function whyGiveIndiaPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function whyGiveIndiaPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function whyGiveIndiaPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function whyGiveIndiaPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) whyGiveIndiaPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) whyGiveIndiaPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function whyGiveIndiaPanel_getPrototypeOf(o) {
    whyGiveIndiaPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return whyGiveIndiaPanel_getPrototypeOf(o);
}
function whyGiveIndiaPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) whyGiveIndiaPanel_setPrototypeOf(subClass, superClass);
}
function whyGiveIndiaPanel_possibleConstructorReturn(self, call) {
    if (call && (whyGiveIndiaPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return whyGiveIndiaPanel_assertThisInitialized(self);
}
function whyGiveIndiaPanel_setPrototypeOf(o, p) {
    whyGiveIndiaPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return whyGiveIndiaPanel_setPrototypeOf(o, p);
}
var whyGiveIndiaPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function whyGiveIndiaPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function whyGiveIndiaPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = whyGiveIndiaPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = whyGiveIndiaPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = whyGiveIndiaPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return whyGiveIndiaPanel_possibleConstructorReturn(this, result);
    };
}
// import './why.scss';
var whyGiveIndiaPanel_config = (0,config["default"])().publicRuntimeConfig;
var whyGiveIndiaPanel_items = [
    {
        imgUrl: '/static/images/home/Monthlygiving.png',
        imgAlt: 'Monthly Giving',
        text: 'Opt to give monthly for our missions or NGO programs and make an impact'
    },
    {
        imgUrl: '/static/images/home/GiveIndiaFundraisers.png',
        imgAlt: 'GiveIndia Fundraisers',
        text: 'Support crowdfunding campaigns with one-time donations'
    },
    {
        imgUrl: '/static/images/home/CorporatePhilanthropy.png',
        imgAlt: 'Corporate Philanthropy',
        text: 'CSR and employee giving through trusted NGOs'
    },
    {
        imgUrl: '/static/images/home/ChoiceofCauses.png',
        imgAlt: 'Choice of Causes',
        text: 'Pick from causes like education, children, livelihoods, etc'
    },
    {
        imgUrl: '/static/images/home/NetworkofVerifiedNGOs.png',
        imgAlt: 'Network of verified NGOs',
        text: 'Partnered with 2,000+ NGOs across the country'
    },
    {
        imgUrl: '/static/images/home/WorldwideGiving.png',
        imgAlt: 'Worldwide giving',
        text: 'Donations in all currencies with tax benefit for India, US and UK'
    }
];
var whyGiveIndiaPanel_index = /*#__PURE__*/ function(Component1) {
    "use strict";
    whyGiveIndiaPanel_inherits(index, Component1);
    var _super = whyGiveIndiaPanel_createSuper(index);
    function index() {
        whyGiveIndiaPanel_classCallCheck(this, index);
        return _super.apply(this, arguments);
    }
    whyGiveIndiaPanel_createClass(index, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "homescreen-why-gi",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hs-why-gi-left container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "India's largest and most trusted giving platform"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hs-why-gi-left-line"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hs-why-gi-left-list",
                                children: whyGiveIndiaPanel_items.map(function(item, idx) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "hs-why-gi-left-item",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(whyGiveIndiaPanel_config.cdnUrl).concat(item.imgUrl),
                                                alt: item.imgAlt,
                                                className: "hs-why-gi-left-item-image"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: item.text
                                            })
                                        ]
                                    }, idx));
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return index;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/elements/panels/donateWithTrustPanel/index.js


function donateWithTrustPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function donateWithTrustPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function donateWithTrustPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function donateWithTrustPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) donateWithTrustPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) donateWithTrustPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function donateWithTrustPanel_getPrototypeOf(o) {
    donateWithTrustPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return donateWithTrustPanel_getPrototypeOf(o);
}
function donateWithTrustPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) donateWithTrustPanel_setPrototypeOf(subClass, superClass);
}
function donateWithTrustPanel_possibleConstructorReturn(self, call) {
    if (call && (donateWithTrustPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return donateWithTrustPanel_assertThisInitialized(self);
}
function donateWithTrustPanel_setPrototypeOf(o, p) {
    donateWithTrustPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return donateWithTrustPanel_setPrototypeOf(o, p);
}
var donateWithTrustPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function donateWithTrustPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function donateWithTrustPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = donateWithTrustPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = donateWithTrustPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = donateWithTrustPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return donateWithTrustPanel_possibleConstructorReturn(this, result);
    };
}
var donateWithTrustPanel_index = /*#__PURE__*/ function(Component1) {
    "use strict";
    donateWithTrustPanel_inherits(index, Component1);
    var _super = donateWithTrustPanel_createSuper(index);
    function index() {
        donateWithTrustPanel_classCallCheck(this, index);
        return _super.apply(this, arguments);
    }
    donateWithTrustPanel_createClass(index, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "dwt",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dwt-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "dwt-header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    "Donate with",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "trust"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dwt-bar"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Through our robust due diligence framework like ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/giveassured",
                                                target: "_blank",
                                                style: {
                                                    color: '#ff5050'
                                                },
                                                children: "GiveAssured"
                                            }),
                                            " and ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "",
                                                style: {
                                                    color: '#ff5050'
                                                },
                                                children: "GiveCompliant"
                                            }),
                                            ", we ensure that critical checks are done for all nonprofit partners and their projects to assure your donations do what it is supposed to - change lives. "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "box-outer-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "box-wrapper first-tile",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "box box-wrapper-b1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "1.7 M+"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Donors have contributed to causes"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "box box-wrapper-b2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "1200 Cr+"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Raised for nonprofits"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "box-wrapper second-tile",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "box box-wrapper-b2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "200+"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Trusted by corporation and brands"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "box box-wrapper-b1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: "10 M"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Lives impacted"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return index;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/elements/panels/supportingFoundations/index.js


function supportingFoundations_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function supportingFoundations_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function supportingFoundations_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function supportingFoundations_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) supportingFoundations_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) supportingFoundations_defineProperties(Constructor, staticProps);
    return Constructor;
}
function supportingFoundations_getPrototypeOf(o) {
    supportingFoundations_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return supportingFoundations_getPrototypeOf(o);
}
function supportingFoundations_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) supportingFoundations_setPrototypeOf(subClass, superClass);
}
function supportingFoundations_possibleConstructorReturn(self, call) {
    if (call && (supportingFoundations_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return supportingFoundations_assertThisInitialized(self);
}
function supportingFoundations_setPrototypeOf(o, p) {
    supportingFoundations_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return supportingFoundations_setPrototypeOf(o, p);
}
var supportingFoundations_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function supportingFoundations_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function supportingFoundations_createSuper(Derived) {
    var hasNativeReflectConstruct = supportingFoundations_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = supportingFoundations_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = supportingFoundations_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return supportingFoundations_possibleConstructorReturn(this, result);
    };
}
var SupportingFoundations = /*#__PURE__*/ function(Component1) {
    "use strict";
    supportingFoundations_inherits(SupportingFoundations, Component1);
    var _super = supportingFoundations_createSuper(SupportingFoundations);
    function SupportingFoundations() {
        supportingFoundations_classCallCheck(this, SupportingFoundations);
        return _super.apply(this, arguments);
    }
    supportingFoundations_createClass(SupportingFoundations, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sf-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sf-wrapper container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sf-logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sf-list-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        // src={
                                        // 	'https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/homeTempv1/supporting-foundations-v2.png'
                                        // }
                                        src: "https://give-marketplace.s3.ap-south-1.amazonaws.com/static/images/home/homeTemp/supporting-foundations-greyscale-v3.jpg",
                                        alt: "supporting-foundation",
                                        loading: "lazy"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sf-content-panel",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sf-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Foundations"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sf-hr"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Trusted by the largest and most impactful foundations worldwide"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return SupportingFoundations;
}(react.Component);
// import './supportingFoundations.scss';


// EXTERNAL MODULE: ./components/chrome/elements/panels/fundraisersPanel/index.js + 1 modules
var fundraisersPanel = __webpack_require__(71629);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/startFundraisersPanel/index.js



function startFundraisersPanel_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function startFundraisersPanel_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function startFundraisersPanel_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function startFundraisersPanel_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) startFundraisersPanel_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) startFundraisersPanel_defineProperties(Constructor, staticProps);
    return Constructor;
}
function startFundraisersPanel_getPrototypeOf(o) {
    startFundraisersPanel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return startFundraisersPanel_getPrototypeOf(o);
}
function startFundraisersPanel_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) startFundraisersPanel_setPrototypeOf(subClass, superClass);
}
function startFundraisersPanel_possibleConstructorReturn(self, call) {
    if (call && (startFundraisersPanel_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return startFundraisersPanel_assertThisInitialized(self);
}
function startFundraisersPanel_setPrototypeOf(o, p) {
    startFundraisersPanel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return startFundraisersPanel_setPrototypeOf(o, p);
}
var startFundraisersPanel_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function startFundraisersPanel_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function startFundraisersPanel_createSuper(Derived) {
    var hasNativeReflectConstruct = startFundraisersPanel_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = startFundraisersPanel_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = startFundraisersPanel_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return startFundraisersPanel_possibleConstructorReturn(this, result);
    };
}
// import './startFundraisersPanel.scss';
var startFundraisersPanel_config = (0,config["default"])().publicRuntimeConfig;
var StartFundraisersPanel = /*#__PURE__*/ function(Component1) {
    "use strict";
    startFundraisersPanel_inherits(StartFundraisersPanel, Component1);
    var _super = startFundraisersPanel_createSuper(StartFundraisersPanel);
    function StartFundraisersPanel() {
        startFundraisersPanel_classCallCheck(this, StartFundraisersPanel);
        return _super.apply(this, arguments);
    }
    startFundraisersPanel_createClass(StartFundraisersPanel, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "start-fundraiser-banner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sfb-container container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sfb-container-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sfb-content",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Raise funds"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                children: "for a cause"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "GiveIndia Fundraisers",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "is a free platform"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://fundraisers.giveindia.org/start-a-campaign?utm_campaign=RaiseFunds&utm_medium=RaiseFundsBlock&utm_term=&utm_content=",
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('start-a-fundraiser-btn', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-primary",
                                            children: "Start a fundraiser"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sfb-container-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(startFundraisersPanel_config.cdnUrl, "/static/images/home/start-fundraiser-desktop.jpg"),
                                    alt: "Start A Fundraiser"
                                })
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return StartFundraisersPanel;
}(react.Component);


;// CONCATENATED MODULE: ./components/chrome/elements/panels/indiaCovidResponse/index.js


function indiaCovidResponse_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function indiaCovidResponse_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function indiaCovidResponse_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function indiaCovidResponse_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) indiaCovidResponse_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) indiaCovidResponse_defineProperties(Constructor, staticProps);
    return Constructor;
}
function indiaCovidResponse_getPrototypeOf(o) {
    indiaCovidResponse_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return indiaCovidResponse_getPrototypeOf(o);
}
function indiaCovidResponse_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) indiaCovidResponse_setPrototypeOf(subClass, superClass);
}
function indiaCovidResponse_possibleConstructorReturn(self, call) {
    if (call && (indiaCovidResponse_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return indiaCovidResponse_assertThisInitialized(self);
}
function indiaCovidResponse_setPrototypeOf(o, p) {
    indiaCovidResponse_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return indiaCovidResponse_setPrototypeOf(o, p);
}
var indiaCovidResponse_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function indiaCovidResponse_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function indiaCovidResponse_createSuper(Derived) {
    var hasNativeReflectConstruct = indiaCovidResponse_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = indiaCovidResponse_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = indiaCovidResponse_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return indiaCovidResponse_possibleConstructorReturn(this, result);
    };
}
var indiaCovidResponse_index = /*#__PURE__*/ function(Component1) {
    "use strict";
    indiaCovidResponse_inherits(index, Component1);
    var _super = indiaCovidResponse_createSuper(index);
    function index() {
        indiaCovidResponse_classCallCheck(this, index);
        return _super.apply(this, arguments);
    }
    indiaCovidResponse_createClass(index, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ind-covid-response",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "icr-content container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icr-header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "India COVID Response Fund"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icr-header-bar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "icr-desciption",
                                children: "India COVID Response Fund (ICRF) is best described as a giving collective that enables both individuals and organisations to respond together to COVID. In 2020, ICRF raised ₹220Cr+, impacting the lives of 56L+ people in India. We re-launched ICRF in April 2021, in response to the grave second wave of COVID to support gaps in healthcare and other critical needs."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icr-box-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "icr-content-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "15L+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Donors supporting COVID missions across healthcare, humanitarian and cash relief"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "icr-content-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "300+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "NGOs and implementation partners working to create widespread impact"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "icr-content-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "65L+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Indians supported across 22 states with funds for our COVID relief work"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icr-btn-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://cfstatic.giveindia.org/a1a4829a-2a74-4b0a-96b7-7c5d9b46a24f.pdf",
                                        target: "_blank",
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('icrf-2020-report-card', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-lg btn-secondary",
                                            children: "See 2020 COVID report"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://e.issuu.com/embed.html?d=icrf-2_final_report_issu&hideIssuuLogo=true&hideShareButton=true&u=giveindia",
                                        target: "_blank",
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('icrf-2021-report-card', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-lg btn-secondary",
                                            children: "See 2021 COVID report"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://covid.giveindia.org/?utm_campaign=ICRF2&utm_medium=ICRFBlock&utm_term=&utm_content=",
                                        target: "_blank",
                                        onClick: function() {
                                            if (window.eventDispatcher) {
                                                window.eventDispatcher.dispatchEventSync('icrf-donate-now', {}, {
                                                    amplitude: true
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-lg btn-primary",
                                            children: "Donate now"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return index;
}(react.Component);
// import './indiaCovidResponse.scss';


;// CONCATENATED MODULE: ./components/chrome/elements/panels/index.js






































/***/ }),

/***/ 66172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ missionsCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Container.js
var Container = __webpack_require__(98595);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(10267);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(51252);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Card.js
var Card = __webpack_require__(56941);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardText.js
var CardText = __webpack_require__(26094);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Progress.js
var Progress = __webpack_require__(90436);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(97975);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/chrome/elements/panels/missionsCard/missionsCardHome.js





var missionsCardHome_config = (0,config["default"])().publicRuntimeConfig;
var MissionsCardHome = function(props) {
    var _mission = props.mission, slug = _mission.slug, image = _mission.image, buttonText = _mission.buttonText, stats = _mission.stats, name = _mission.name;
    var number = stats.percentage_reached;
    var completed_percentage = Math.floor(number, -2);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
        lg: "4",
        md: "6",
        sm: "12",
        xs: "12",
        className: "mission-card-homepage",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/missions/".concat(slug),
                onClick: function() {
                    var eventInfo = {
                        missionName: name
                    };
                    if (window.eventDispatcher) {
                        window.eventDispatcher.dispatchEventSync('missions-card', eventInfo, {
                            amplitude: true
                        });
                    }
                    return true;
                },
                style: {
                    textDecoration: 'none'
                },
                className: "jsx-ef8013201da79b1e",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: "missions-card mcm-tile",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: 'relative'
                            },
                            className: "jsx-ef8013201da79b1e",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                style: {
                                    width: '100%'
                                },
                                src: "".concat(missionsCardHome_config.cdnUrl).concat(image.imgUrlPath).concat(image.imgUrl),
                                alt: image.imgAlt,
                                loading: "lazy",
                                className: "jsx-ef8013201da79b1e"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardText/* default */.Z, {
                            className: "missions-card-text-box ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-ef8013201da79b1e" + " " + "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-ef8013201da79b1e" + " " + "supporting-card-bold-text first-element-name ",
                                        children: name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-ef8013201da79b1e" + " " + "progress-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
                                            className: "supporter-process-bar",
                                            value: stats.percentage_reached
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                paddingTop: '10px',
                                                paddingBottom: '10px'
                                            },
                                            className: "jsx-ef8013201da79b1e",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: '#444444'
                                                },
                                                className: "jsx-ef8013201da79b1e",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "jsx-ef8013201da79b1e",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-ef8013201da79b1e" + " " + " monthly-count-supporters",
                                                                children: stats.monthly_supporters
                                                            }),
                                                            ' ',
                                                            "monthly supporters"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "jsx-ef8013201da79b1e" + " " + " completed-supporters",
                                                        children: [
                                                            completed_percentage,
                                                            "%",
                                                            ' '
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/missions/".concat(slug),
                                    onClick: function() {
                                        var eventInfo = {
                                            missionName: name
                                        };
                                        if (window.eventDispatcher) {
                                            window.eventDispatcher.dispatchEventSync('missions-card-btn', eventInfo, {
                                                amplitude: true
                                            });
                                        }
                                    },
                                    className: "jsx-ef8013201da79b1e",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "primary",
                                        className: "btn-full-width btn btn-primary",
                                        children: buttonText
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "ef8013201da79b1e",
                children: ".first-element-name::first-word{color:#000000!important}\n@media (max-width:1023px) {.mission-card-homepage{margin-bottom:1rem}}\n@media (max-width:767px) {.mission-card-homepage{margin-bottom:1rem;\npadding:0}\n.mcm-tile{margin-bottom:0!important}}\n.missions-card.card{box-shadow:0 1px 5px 0 rgba(0, 0, 0, 0.2)}\n.missions-card-text-box{padding:1rem}\n@media (max-width:768px) {.missions-card-text-box{padding:1rem}\n.missions-card.card{box-shadow:0 1px 5px 0 rgba(0, 0, 0, 0.2)}\n.missions-card-for-mobile{padding:0px}}\n.card-price{margin-bottom:10px}\n.card-price h6{margin-bottom:0;\nfont-weight:600}\n.tag-row{margin-bottom:10px}\n.giveassured-position{position:absolute;\nbottom:3px;\nright:3px;\nbackground:white;\npadding:1px 5px;\nborder-radius:5px;\nbox-shadow:0 2px 2px rgba(50, 50, 93, 0), 0 1px 2px rgba(0, 0, 0, 0.08)}\n.supporting-card-bold-text{font-weight:600;\nfont-size:18px;\ncolor:#ff5050!important}\n.supporter-process-bar.progress{height:8px!important}\n.supporter-process-bar .progress-bar{background:#ff5050!important}\n.completed-supporters{float:right;\ncolor:#666666!important}\n.monthly-count-supporters{color:#666666!important}"
            })
        ]
    }));
};
/* harmony default export */ var missionsCardHome = (MissionsCardHome);

;// CONCATENATED MODULE: ./components/chrome/elements/panels/missionsCard/index.js





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var MissionsCard = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(MissionsCard, _Component);
    var _super = _createSuper(MissionsCard);
    function MissionsCard(props) {
        _classCallCheck(this, MissionsCard);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            missionsData: []
        };
        return _this;
    }
    _createClass(MissionsCard, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, missions = _props.missions, title = _props.title, activeTab = _props.activeTab;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "panel-padding ",
                    children: [
                        activeTab === "monthlygiving" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "jsx-78b2a3106dc201f5" + " " + "monthly-mission-heading",
                                    children: "Monthly Giving Missions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-78b2a3106dc201f5" + " " + "sub-divider-heading"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: missions === null || missions === void 0 ? void 0 : missions.map(function(mission, indexma) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(missionsCardHome, {
                                    mission: mission
                                }, indexma);
                            })
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "78b2a3106dc201f5",
                            children: ".btn-view-all-homepage{display:inline-block;\nfont-weight:100;\ntext-align:center;\nwhite-space:nowrap;\nvertical-align:middle;\n-webkit-user-select:none;\n-moz-user-select:none;\n-ms-user-select:none;\nuser-select:none;\nborder:1px solid transparent;\npadding:4px 9px;\nfont-size:1rem;\nline-height:1.5!important;\nborder-radius:0.3rem;\nfont-family:Nunito Sans, sans-serif;\n-webkit-transition:background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\ntransition:background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n-webkit-text-decoration:none;\ntext-decoration:none}\n.homepage-btn-color{padding:0.3rem 2rem;\nfont-size:16px;\nline-height:1.5!important;\nborder-radius:0.3rem;\ncolor:#999999!important;\nbackground-color:#fbfbfb!important;\nborder-color:#999999!important;\nbackground-image:none}\n.missions-panel-btm-view-all{padding-top:2rem}\n@media (max-width:576px) {.missions-panel-btm-view-all{padding:0px}}"
                        })
                    ]
                }));
            }
        }
    ]);
    return MissionsCard;
}(react.Component);
/* harmony default export */ var missionsCard = (MissionsCard);


/***/ }),

/***/ 78970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98595);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10267);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51252);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15538);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82669);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(609);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97975);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_contextual__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80224);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11752);







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var config = (0,next_config__WEBPACK_IMPORTED_MODULE_4__["default"])().publicRuntimeConfig;
var NewsletterPanel = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(NewsletterPanel, _Component);
    var _super = _createSuper(NewsletterPanel);
    function NewsletterPanel(props) {
        _classCallCheck(this, NewsletterPanel);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "submitNewsletterSubscriptionForm", function(event) {
            event.preventDefault();
            var name = document.getElementById('ns-sub-panel-name').value;
            var email = document.getElementById('ns-sub-panel-email').value;
            axios__WEBPACK_IMPORTED_MODULE_3___default()({
                method: 'post',
                url: "/api/v1.1/leadGen/create",
                data: {
                    email: email,
                    name: name,
                    source: 'newsletters',
                    _csrf: _this.props._csrf
                }
            }).then(function(res) {
                if (res.data.status) {
                    var eventData = {
                        content_name: "newsletter-registration",
                        status: true
                    };
                    if (window.eventDispatcher) {
                        window.eventDispatcher.dispatchEvent('Lead', eventData, {
                            fbPixel: true
                        });
                    }
                    _this.setState({
                        messageSubmitted: true,
                        message: 'Thank you for signing up!'
                    });
                } else {
                    _this.setState({
                        messageSubmitted: true,
                        message: 'You have already signed up for our newsletter'
                    });
                }
            }).catch(function(err) {});
        });
        _this.state = {
            messageSubmitted: false
        };
        return _this;
    }
    _createClass(NewsletterPanel, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: "panel-padding",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "newsletter-box d-flex",
                            style: {
                                height: "auto",
                                overflow: 'hidden'
                            },
                            sm: "12",
                            xs: "12",
                            md: "12",
                            lg: "12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    xs: "6",
                                    lg: "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        style: {
                                            width: '100%',
                                            marginRight: 'auto',
                                            overflow: 'hidden'
                                        },
                                        src: "".concat(config.cdnUrl, "/static/images/Illustration-boy-leadgen-final.svg"),
                                        alt: "Newsletter subscription image",
                                        className: "jsx-f97713bde5a06a9a" + " " + "newsletter-image-panel"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    xs: "6",
                                    lg: "3",
                                    className: " d-flex justify-content-center align-self-center hide-mobile",
                                    /*#__PURE__*/ children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                        className: "jsx-f97713bde5a06a9a",
                                        children: "Weekly dose of inspiration delivered straight to your inbox. Sign up here."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    xs: "12",
                                    lg: "7",
                                    className: "d-flex justify-content-center align-self-center newsletter-field-panel col-md-7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        className: "w-100",
                                        children: !this.state.messageSubmitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: "form-inline w-100",
                                            onSubmit: function(e) {
                                                return _this.submitNewsletterSubscriptionForm(e);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    xs: "12",
                                                    lg: "5",
                                                    className: "footer-panel-f4",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            required: true,
                                                            type: "text",
                                                            name: "name",
                                                            id: "ns-sub-panel-name",
                                                            placeholder: "Your Name"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    xs: "12",
                                                    lg: "5",
                                                    className: "footer-panel-f4",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            required: true,
                                                            type: "email",
                                                            name: "Email",
                                                            id: "ns-sub-panel-email",
                                                            placeholder: "Enter your e-mail"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    xs: "12",
                                                    lg: "2",
                                                    className: "footer-panel-f4 p-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            color: "secondary",
                                                            className: "btn-lg",
                                                            children: " sign up"
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                alignItems: 'center',
                                                maxWidth: '100%'
                                            },
                                            className: "jsx-f97713bde5a06a9a" + " " + "justify-content-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                style: {
                                                    paddingTop: '1rem',
                                                    fontSize: '20px'
                                                },
                                                className: "jsx-f97713bde5a06a9a",
                                                children: this.state.message
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                            id: "f97713bde5a06a9a",
                            children: "@media (max-width:768px) {.footer-panel-f4{padding:0px 0px 0px 0px!important}}\n.newsletter-box{overflow:hidden;\nborder-radius:10px;\nbox-shadow:0 2px 4px 0 rgba(50, 50, 93, .1);\nborder:1px solid rgba(0, 0, 0, 0.03)}\n.newsletter-box .form-inline .form-group{margin-bottom:1rem}\n.newsletter-field-panel{padding-top:1rem}"
                        })
                    ]
                }));
            }
        }
    ]);
    return NewsletterPanel;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_contextual__WEBPACK_IMPORTED_MODULE_12__/* .subscribe */ .Ld)()(NewsletterPanel));


/***/ }),

/***/ 13433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98595);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10267);
/* harmony import */ var _cards__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10841);
/* harmony import */ var _common_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50386);
/* harmony import */ var _common_colors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_common_colors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _icons_rightArrowSmall__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2386);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83633);









var ProgramPanel = function(props) {
    var title = props.title, programs = props.programs, viewAll = props.viewAll, session = props.session, width = props.width, AB = props.AB, newTab = props.newTab, defaultMatchingPercentage = props.defaultMatchingPercentage, tenantConfig = props.tenantConfig, theme = props.theme;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: "panel-padding",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), {
                minWidth: 576,
                device: {
                    width: width
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: viewAll,
                            onClick: function() {
                                var eventInfo = {
                                    prevPage: title.split(' ')[0]
                                };
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, {
                                        amplitude: true
                                    });
                                }
                                return true;
                            },
                            className: "no-hover-a",
                            style: {
                                cursor: 'pointer'
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "mr-auto",
                                style: {
                                    marginBottom: '2rem'
                                },
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: viewAll,
                            onClick: function() {
                                var eventInfo = {
                                    prevPage: title.split(' ')[0]
                                };
                                if (window.eventDispatcher) {
                                    window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, {
                                        amplitude: true
                                    });
                                }
                                return true;
                            },
                            className: "ml-auto no-hover-a",
                            style: {
                                fontSize: '0.875rem',
                                color: (_common_colors__WEBPACK_IMPORTED_MODULE_5___default().giveDarkerGrey)
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        paddingRight: '6px'
                                    },
                                    children: "View All"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_rightArrowSmall__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), {
                maxWidth: 576,
                device: {
                    width: width
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    style: {
                        paddingLeft: '15px'
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: function() {
                            var eventInfo = {
                                prevPage: title.split(' ')[0]
                            };
                            if (window.eventDispatcher) {
                                window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, {
                                    amplitude: true
                                });
                            }
                            return true;
                        },
                        href: viewAll,
                        className: "no-hover-a",
                        style: {
                            cursor: 'pointer'
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "mr-auto",
                            style: {
                                marginBottom: '2rem'
                            },
                            children: title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: programs && programs.map(function(program1, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_4__/* .ProgramCard */ .B1, {
                        type: "homePage",
                        panelTitle: title,
                        position: index,
                        matching: program1.matching,
                        program: program1,
                        session: session,
                        AB: AB,
                        theme: theme,
                        newTab: newTab,
                        lazyLoadImage: true,
                        defaultMatchingPercentage: defaultMatchingPercentage,
                        tenantConfig: tenantConfig
                    }, "program-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), {
                maxWidth: 576,
                device: {
                    width: width
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    style: {
                        paddingRight: '15px'
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        onClick: function() {
                            var eventInfo = {
                                prevPage: title.split(' ')[0]
                            };
                            if (window.eventDispatcher) {
                                window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, {
                                    amplitude: true
                                });
                            }
                            return true;
                        },
                        href: viewAll,
                        className: "ml-auto no-hover-a",
                        style: {
                            fontSize: '0.875rem',
                            color: (_common_colors__WEBPACK_IMPORTED_MODULE_5___default().giveDarkerGrey)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    paddingRight: '6px'
                                },
                                children: "View All"
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_rightArrowSmall__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        ]
                    })
                })
            })
        ]
    }));
};
ProgramPanel.propTypes = {
    programs: prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
        title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        programLink: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        cause: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        location: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        ngo: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        image: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
        price: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number.isRequired)
    })).isRequired,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    viewAll: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (ProgramPanel);


/***/ }),

/***/ 54868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _deviceInfoContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75653);




function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var RenderByDeviceType = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(RenderByDeviceType, _Component);
    var _super = _createSuper(RenderByDeviceType);
    function RenderByDeviceType() {
        _classCallCheck(this, RenderByDeviceType);
        return _super.apply(this, arguments);
    }
    _createClass(RenderByDeviceType, [
        {
            key: "render",
            value: function render() {
                var desktopView = this.props.desktop;
                var mobileView = this.props.mobile;
                var tabletView = this.props.tablet || this.props.desktop;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deviceInfoContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Consumer */ .Z.Consumer, {
                        children: function(deviceInfo) {
                            if (deviceInfo.device === 'mobile') {
                                return mobileView;
                            }
                            if (deviceInfo.device === 'tablet') {
                                return tabletView;
                            }
                            return desktopView;
                        }
                    })
                }));
            }
        }
    ]);
    return RenderByDeviceType;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
RenderByDeviceType.propTypes = {
    desktop: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().element.isRequired),
    mobile: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().element.isRequired),
    tablet: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().element)
};
/* harmony default export */ __webpack_exports__["Z"] = (RenderByDeviceType);


/***/ }),

/***/ 91121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23663);






var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_3__/* .tagPropType */ .iC,
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)])
};
var defaultProps = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      innerRef = props.innerRef,
      Tag = props.tag,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, ["className", "cssModule", "innerRef", "tag"]);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'card-body'), cssModule);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);

/***/ }),

/***/ 75351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23663);






var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_3__/* .tagPropType */ .iC,
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};
var defaultProps = {
  tag: 'div'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, ["className", "cssModule", "tag"]);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'card-title'), cssModule);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes
  }));
};

CardTitle.propTypes = propTypes;
CardTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (CardTitle);

/***/ }),

/***/ 15538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94578);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23663);








var propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  inline: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  tag: _utils__WEBPACK_IMPORTED_MODULE_3__/* .tagPropType */ .iC,
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)]),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};
var defaultProps = {
  tag: 'form'
};

var Form =
/*#__PURE__*/
function (_Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
    _this.submit = _this.submit.bind((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
    return _this;
  }

  var _proto = Form.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.submit = function submit() {
    if (this.ref) {
      this.ref.submit();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        inline = _this$props.inline,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);

    var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, inline ? 'form-inline' : false), cssModule);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Form;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Form);

/***/ })

}]);